export const carbonImpurities = [
    {
        names: ['acetic acid'],
        smiles: 'CC(=O)O',
        ranges: [
            {
                signals: [
                    {
                        delta: 171.69,
                        assignment: 'CO',
                    },
                ],
                from: 171.68625,
                to: 171.69375,
            },
            {
                signals: [
                    {
                        delta: 20.13,
                        assignment: 'CH₃',
                    },
                ],
                from: 20.12625,
                to: 20.13375,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['acetone'],
        smiles: 'CC(=O)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 204.19,
                        assignment: 'CO',
                    },
                ],
                from: 204.18625,
                to: 204.19375,
            },
            {
                signals: [
                    {
                        delta: 30.17,
                        assignment: 'CH₃',
                    },
                ],
                from: 30.16625,
                to: 30.173750000000002,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['acetonitrile'],
        smiles: 'CC#N',
        ranges: [
            {
                signals: [
                    {
                        delta: 116.79,
                        assignment: 'CN',
                    },
                ],
                from: 116.78625000000001,
                to: 116.79375,
            },
            {
                signals: [
                    {
                        delta: 0.45,
                        assignment: 'CH₃',
                    },
                ],
                from: 0.44625000000000004,
                to: 0.45375,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['benzene'],
        smiles: 'c1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        delta: 128.84,
                        assignment: 'CH',
                    },
                ],
                from: 128.83625,
                to: 128.84375,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['tert -butyl alcohol'],
        smiles: 'CC(C)(C)O',
        ranges: [
            {
                signals: [
                    {
                        delta: 67.5,
                        assignment: '(CH₃)₃C',
                    },
                ],
                from: 67.49625,
                to: 67.50375,
            },
            {
                signals: [
                    {
                        delta: 30.57,
                        assignment: '(CH₃)₃C',
                    },
                ],
                from: 30.56625,
                to: 30.57375,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['carbon dioxide'],
        smiles: 'O=C=O',
        ranges: [
            {
                signals: [
                    {
                        delta: 125.69,
                        assignment: 'CO₂',
                    },
                ],
                from: 125.68625,
                to: 125.69375,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['carbon disulfide'],
        smiles: 'S=C=S',
        ranges: [
            {
                signals: [
                    {
                        delta: 193.37,
                        assignment: 'CS₂',
                    },
                ],
                from: 193.36625,
                to: 193.37375,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['carbon tetrachloride'],
        smiles: 'ClC(Cl)(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        delta: 96.89,
                        assignment: 'CCl₄',
                    },
                ],
                from: 96.88625,
                to: 96.89375,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['chloroform'],
        smiles: 'ClC(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        delta: 79.24,
                        assignment: 'CH',
                    },
                ],
                from: 79.23625,
                to: 79.24374999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['18-crown-6'],
        smiles: 'C1COCCOCCOCCOCCOCCO1',
        ranges: [
            {
                signals: [
                    {
                        delta: 71.34,
                        assignment: 'CH₂',
                    },
                ],
                from: 71.33625,
                to: 71.34375,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['cyclohexane'],
        smiles: 'C1CCCCC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 27.58,
                        assignment: 'CH₂',
                    },
                ],
                from: 27.576249999999998,
                to: 27.58375,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['1,2-dichloroethane'],
        smiles: 'ClCCCl',
        ranges: [
            {
                signals: [
                    {
                        delta: 44.64,
                        assignment: 'CH₂',
                    },
                ],
                from: 44.636250000000004,
                to: 44.64375,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['dichloromethane'],
        smiles: 'ClCCl',
        ranges: [
            {
                signals: [
                    {
                        delta: 54.67,
                        assignment: 'CH₂',
                    },
                ],
                from: 54.666250000000005,
                to: 54.67375,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 15.49,
                        assignment: 'CH₃',
                    },
                ],
                from: 15.48625,
                to: 15.49375,
            },
            {
                signals: [
                    {
                        delta: 66.14,
                        assignment: 'CH₂',
                    },
                ],
                from: 66.13625,
                to: 66.14375,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['diglyme'],
        smiles: 'COCCOCCOC',
        ranges: [
            {
                signals: [
                    {
                        delta: 58.72,
                        assignment: 'CH₃',
                    },
                ],
                from: 58.71625,
                to: 58.723749999999995,
            },
            {
                signals: [
                    {
                        delta: 71.17,
                        assignment: 'CH₂',
                    },
                ],
                from: 71.16625,
                to: 71.17375,
            },
            {
                signals: [
                    {
                        delta: 72.72,
                        assignment: 'CH₂',
                    },
                ],
                from: 72.71625,
                to: 72.72375,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['dimethylformamide'],
        smiles: 'C(=O)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 161.96,
                        assignment: 'CH',
                    },
                ],
                from: 161.95625,
                to: 161.96375,
            },
            {
                signals: [
                    {
                        delta: 35.65,
                        assignment: 'CH₃',
                    },
                ],
                from: 35.64625,
                to: 35.653749999999995,
            },
            {
                signals: [
                    {
                        delta: 30.7,
                        assignment: 'CH₃',
                    },
                ],
                from: 30.69625,
                to: 30.70375,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['1,4-dioxane'],
        smiles: 'C1COCCOC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 67.65,
                        assignment: 'CH₂',
                    },
                ],
                from: 67.64625000000001,
                to: 67.65375,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['DME', 'diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 58.72,
                        assignment: 'CH₃',
                    },
                ],
                from: 58.71625,
                to: 58.723749999999995,
            },
            {
                signals: [
                    {
                        delta: 72.58,
                        assignment: 'CH₂',
                    },
                ],
                from: 72.57625,
                to: 72.58375,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['ethane'],
        smiles: 'CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 6.79,
                        assignment: 'CH₃',
                    },
                ],
                from: 6.78625,
                to: 6.79375,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['ethanol'],
        smiles: 'CCO',
        ranges: [
            {
                signals: [
                    {
                        delta: 18.9,
                        assignment: 'CH₃',
                    },
                ],
                from: 18.89625,
                to: 18.90375,
            },
            {
                signals: [
                    {
                        delta: 57.6,
                        assignment: 'CH₂',
                    },
                ],
                from: 57.596250000000005,
                to: 57.60375,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['ethyl acetate'],
        smiles: 'CC(=O)CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 20.45,
                        assignment: 'CH₃CO',
                    },
                ],
                from: 20.44625,
                to: 20.45375,
            },
            {
                signals: [
                    {
                        delta: 170.32,
                        assignment: 'CO',
                    },
                ],
                from: 170.31625,
                to: 170.32375,
            },
            {
                signals: [
                    {
                        delta: 60.3,
                        assignment: 'CH₂',
                    },
                ],
                from: 60.29625,
                to: 60.303749999999994,
            },
            {
                signals: [
                    {
                        delta: 14.37,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.366249999999999,
                to: 14.37375,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['ethylene'],
        smiles: 'C=C',
        ranges: [
            {
                signals: [
                    {
                        delta: 123.09,
                        assignment: 'CH₂',
                    },
                ],
                from: 123.08625,
                to: 123.09375,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['ethylene glycol'],
        smiles: 'OCCO',
        ranges: [
            {
                signals: [
                    {
                        delta: 64.35,
                        assignment: 'CH₂',
                    },
                ],
                from: 64.34625,
                to: 64.35374999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['H grease'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        delta: 30.45,
                        assignment: 'CH₂',
                    },
                ],
                from: 30.44625,
                to: 30.45375,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['hexamethylbenzene'],
        smiles: 'CC1=C(C(=C(C(=C1C)C)C)C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 131.88,
                        assignment: 'C',
                    },
                ],
                from: 131.87625,
                to: 131.88375,
            },
            {
                signals: [
                    {
                        delta: 16.71,
                        assignment: 'CH₃',
                    },
                ],
                from: 16.70625,
                to: 16.71375,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['n-hexane'],
        smiles: 'CCCCCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 14.22,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.21625,
                to: 14.22375,
            },
            {
                signals: [
                    {
                        delta: 23.33,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 23.326249999999998,
                to: 23.33375,
            },
            {
                signals: [
                    {
                        delta: 32.34,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 32.33625000000001,
                to: 32.34375,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['HMDSO'],
        smiles: 'C[Si](C)(C)O[Si](C)(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 1.83,
                        assignment: 'CH₃',
                    },
                ],
                from: 1.8262500000000002,
                to: 1.83375,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['HMPA'],
        smiles: 'CN(C)P(=O)(N(C)C)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 36.89,
                        assignment: 'CH₃',
                    },
                ],
                from: 36.886250000000004,
                to: 36.89375,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['imidazole'],
        smiles: 'C1=CN=CN1',
        ranges: [
            {
                signals: [
                    {
                        delta: 135.72,
                        assignment: 'CH(2)',
                    },
                ],
                from: 135.71625,
                to: 135.72375,
            },
            {
                signals: [
                    {
                        delta: 122.2,
                        assignment: 'CH(4,5)',
                    },
                ],
                from: 122.19625,
                to: 122.20375,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['methane'],
        smiles: 'C',
        ranges: [
            {
                signals: [
                    {
                        delta: -4.9,
                        assignment: 'CH₄',
                    },
                ],
                from: -4.9037500000000005,
                to: -4.89625,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['methanol'],
        smiles: 'CO',
        ranges: [
            {
                signals: [
                    {
                        delta: 49.64,
                        assignment: 'CH₃',
                    },
                ],
                from: 49.636250000000004,
                to: 49.64375,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['nitromethane'],
        smiles: 'C[N+](=O)[O-]',
        ranges: [
            {
                signals: [
                    {
                        delta: 62.49,
                        assignment: 'CH₃',
                    },
                ],
                from: 62.486250000000005,
                to: 62.49375,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['n-pentane'],
        smiles: 'CCCCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 14.18,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.17625,
                to: 14.18375,
            },
            {
                signals: [
                    {
                        delta: 23,
                        assignment: 'CH₂(2,4)',
                    },
                ],
                from: 22.99625,
                to: 23.00375,
            },
            {
                signals: [
                    {
                        delta: 34.87,
                        assignment: 'CH₂(3)',
                    },
                ],
                from: 34.86625,
                to: 34.873749999999994,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['propane'],
        smiles: 'CCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 16.6,
                        assignment: 'CH₃',
                    },
                ],
                from: 16.59625,
                to: 16.60375,
            },
            {
                signals: [
                    {
                        delta: 16.82,
                        assignment: 'CH₂',
                    },
                ],
                from: 16.81625,
                to: 16.82375,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['2-propanol'],
        smiles: 'CC(O)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 25.7,
                        assignment: 'CH₃',
                    },
                ],
                from: 25.69625,
                to: 25.70375,
            },
            {
                signals: [
                    {
                        delta: 66.14,
                        assignment: 'CH',
                    },
                ],
                from: 66.13625,
                to: 66.14375,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['propylene'],
        smiles: 'CC=C',
        ranges: [
            {
                signals: [
                    {
                        delta: 19.27,
                        assignment: 'CH₃',
                    },
                ],
                from: 19.26625,
                to: 19.27375,
            },
            {
                signals: [
                    {
                        delta: 115.74,
                        assignment: 'CH₂',
                    },
                ],
                from: 115.73625,
                to: 115.74374999999999,
            },
            {
                signals: [
                    {
                        delta: 134.02,
                        assignment: 'CH',
                    },
                ],
                from: 134.01625,
                to: 134.02375,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['pyridine'],
        smiles: 'C1=CC=NC=C1',
        ranges: [
            {
                signals: [
                    {
                        delta: 150.57,
                        assignment: 'CH(2,6)',
                    },
                ],
                from: 150.56625,
                to: 150.57375,
            },
            {
                signals: [
                    {
                        delta: 124.08,
                        assignment: 'CH(3,5)',
                    },
                ],
                from: 124.07625,
                to: 124.08375,
            },
            {
                signals: [
                    {
                        delta: 135.99,
                        assignment: 'CH(4)',
                    },
                ],
                from: 135.98625,
                to: 135.99375,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['pyrrole'],
        smiles: 'C1=CNC=C1',
        ranges: [
            {
                signals: [
                    {
                        delta: 118.03,
                        assignment: 'CH(2,5)',
                    },
                ],
                from: 118.02625,
                to: 118.03375,
            },
            {
                signals: [
                    {
                        delta: 107.74,
                        assignment: 'CH(3,4)',
                    },
                ],
                from: 107.73625,
                to: 107.74374999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['pyrrolidine'],
        smiles: 'C1CCNC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 45.82,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 45.816250000000004,
                to: 45.82375,
            },
            {
                signals: [
                    {
                        delta: 26.17,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 26.16625,
                to: 26.173750000000002,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['silicone grease'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        delta: 1.2,
                        assignment: 'CH₃',
                    },
                ],
                from: 1.19625,
                to: 1.2037499999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['tetrahydrofuran'],
        smiles: 'C1COCC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 68.03,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 68.02625,
                to: 68.03375,
            },
            {
                signals: [
                    {
                        delta: 26.19,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 26.18625,
                to: 26.19375,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['toluene'],
        smiles: 'Cc1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        delta: 21.29,
                        assignment: 'CH₃',
                    },
                ],
                from: 21.28625,
                to: 21.29375,
            },
            {
                signals: [
                    {
                        delta: 138.24,
                        assignment: 'C(1)',
                    },
                ],
                from: 138.23625,
                to: 138.24375,
            },
            {
                signals: [
                    {
                        delta: 129.47,
                        assignment: 'CH(2,6)',
                    },
                ],
                from: 129.46625,
                to: 129.47375,
            },
            {
                signals: [
                    {
                        delta: 128.71,
                        assignment: 'CH(3,5)',
                    },
                ],
                from: 128.70625,
                to: 128.71375,
            },
            {
                signals: [
                    {
                        delta: 125.84,
                        assignment: 'CH(4)',
                    },
                ],
                from: 125.83625,
                to: 125.84375,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['triethylamine'],
        smiles: 'CCN(CC)CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 12.51,
                        assignment: 'CH₃',
                    },
                ],
                from: 12.50625,
                to: 12.51375,
            },
            {
                signals: [
                    {
                        delta: 47.18,
                        assignment: 'CH₂',
                    },
                ],
                from: 47.17625,
                to: 47.183749999999996,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['acetic acid'],
        smiles: 'CC(=O)O',
        ranges: [
            {
                signals: [
                    {
                        delta: 175.85,
                        assignment: 'CO',
                    },
                ],
                from: 175.84625,
                to: 175.85375,
            },
            {
                signals: [
                    {
                        delta: 20.91,
                        assignment: 'CH₃',
                    },
                ],
                from: 20.90625,
                to: 20.91375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['acetone'],
        smiles: 'CC(=O)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 206.78,
                        assignment: 'CO',
                    },
                ],
                from: 206.77625,
                to: 206.78375,
            },
            {
                signals: [
                    {
                        delta: 31,
                        assignment: 'CH₃',
                    },
                ],
                from: 30.99625,
                to: 31.00375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['acetonitrile'],
        smiles: 'CC#N',
        ranges: [
            {
                signals: [
                    {
                        delta: 116.92,
                        assignment: 'CN',
                    },
                ],
                from: 116.91625,
                to: 116.92375,
            },
            {
                signals: [
                    {
                        delta: 2.03,
                        assignment: 'CH₃',
                    },
                ],
                from: 2.0262499999999997,
                to: 2.03375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['benzene'],
        smiles: 'c1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        delta: 128.68,
                        assignment: 'CH',
                    },
                ],
                from: 128.67625,
                to: 128.68375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['tert -butyl alcohol'],
        smiles: 'CC(C)(C)O',
        ranges: [
            {
                signals: [
                    {
                        delta: 69.11,
                        assignment: '(CH₃)₃C',
                    },
                ],
                from: 69.10625,
                to: 69.11375,
            },
            {
                signals: [
                    {
                        delta: 31.46,
                        assignment: '(CH₃)₃C',
                    },
                ],
                from: 31.45625,
                to: 31.46375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['carbon dioxide'],
        smiles: 'O=C=O',
        ranges: [
            {
                signals: [
                    {
                        delta: 125.26,
                        assignment: 'CO₂',
                    },
                ],
                from: 125.25625000000001,
                to: 125.26375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['carbon disulfide'],
        smiles: 'S=C=S',
        ranges: [
            {
                signals: [
                    {
                        delta: 192.95,
                        assignment: 'CS₂',
                    },
                ],
                from: 192.94625,
                to: 192.95374999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['carbon tetrachloride'],
        smiles: 'ClC(Cl)(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        delta: 96.52,
                        assignment: 'CCl₄',
                    },
                ],
                from: 96.51625,
                to: 96.52374999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['chloroform'],
        smiles: 'ClC(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        delta: 77.99,
                        assignment: 'CH',
                    },
                ],
                from: 77.98625,
                to: 77.99374999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['18-crown-6'],
        smiles: 'C1COCCOCCOCCOCCOCCO1',
        ranges: [
            {
                signals: [
                    {
                        delta: 70.47,
                        assignment: 'CH₂',
                    },
                ],
                from: 70.46625,
                to: 70.47375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['cyclohexane'],
        smiles: 'C1CCCCC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 27.38,
                        assignment: 'CH₂',
                    },
                ],
                from: 27.37625,
                to: 27.38375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['1,2-dichloroethane'],
        smiles: 'ClCCCl',
        ranges: [
            {
                signals: [
                    {
                        delta: 44.35,
                        assignment: 'CH₂',
                    },
                ],
                from: 44.346250000000005,
                to: 44.35375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['dichloromethane'],
        smiles: 'ClCCl',
        ranges: [
            {
                signals: [
                    {
                        delta: 54.24,
                        assignment: 'CH₂',
                    },
                ],
                from: 54.236250000000005,
                to: 54.24375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 15.44,
                        assignment: 'CH₃',
                    },
                ],
                from: 15.43625,
                to: 15.44375,
            },
            {
                signals: [
                    {
                        delta: 66.11,
                        assignment: 'CH₂',
                    },
                ],
                from: 66.10625,
                to: 66.11375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['diglyme'],
        smiles: 'COCCOCCOC',
        ranges: [
            {
                signals: [
                    {
                        delta: 58.95,
                        assignment: 'CH₃',
                    },
                ],
                from: 58.946250000000006,
                to: 58.95375,
            },
            {
                signals: [
                    {
                        delta: 70.7,
                        assignment: 'CH₂',
                    },
                ],
                from: 70.69625,
                to: 70.70375,
            },
            {
                signals: [
                    {
                        delta: 72.25,
                        assignment: 'CH₂',
                    },
                ],
                from: 72.24625,
                to: 72.25375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['dimethylformamide'],
        smiles: 'C(=O)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 162.57,
                        assignment: 'CH',
                    },
                ],
                from: 162.56625,
                to: 162.57375,
            },
            {
                signals: [
                    {
                        delta: 36.56,
                        assignment: 'CH₃',
                    },
                ],
                from: 36.556250000000006,
                to: 36.56375,
            },
            {
                signals: [
                    {
                        delta: 31.39,
                        assignment: 'CH₃',
                    },
                ],
                from: 31.38625,
                to: 31.39375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['1,4-dioxane'],
        smiles: 'C1COCCOC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 67.47,
                        assignment: 'CH₂',
                    },
                ],
                from: 67.46625,
                to: 67.47375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['DME', 'diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 59.02,
                        assignment: 'CH₃',
                    },
                ],
                from: 59.01625000000001,
                to: 59.02375,
            },
            {
                signals: [
                    {
                        delta: 72.24,
                        assignment: 'CH₂',
                    },
                ],
                from: 72.23625,
                to: 72.24374999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['ethane'],
        smiles: 'CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 6.91,
                        assignment: 'CH₃',
                    },
                ],
                from: 6.90625,
                to: 6.91375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['ethanol'],
        smiles: 'CCO',
        ranges: [
            {
                signals: [
                    {
                        delta: 18.69,
                        assignment: 'CH₃',
                    },
                ],
                from: 18.68625,
                to: 18.69375,
            },
            {
                signals: [
                    {
                        delta: 58.57,
                        assignment: 'CH₂',
                    },
                ],
                from: 58.566250000000004,
                to: 58.57375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['ethyl acetate'],
        smiles: 'CC(=O)CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 21.15,
                        assignment: 'CH₃CO',
                    },
                ],
                from: 21.14625,
                to: 21.15375,
            },
            {
                signals: [
                    {
                        delta: 171.24,
                        assignment: 'CO',
                    },
                ],
                from: 171.23625,
                to: 171.24375,
            },
            {
                signals: [
                    {
                        delta: 60.63,
                        assignment: 'CH₂',
                    },
                ],
                from: 60.626250000000006,
                to: 60.63375,
            },
            {
                signals: [
                    {
                        delta: 14.37,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.366249999999999,
                to: 14.37375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['ethylene'],
        smiles: 'C=C',
        ranges: [
            {
                signals: [
                    {
                        delta: 123.2,
                        assignment: 'CH₂',
                    },
                ],
                from: 123.19625,
                to: 123.20375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['ethylene glycol'],
        smiles: 'OCCO',
        ranges: [
            {
                signals: [
                    {
                        delta: 64.08,
                        assignment: 'CH₂',
                    },
                ],
                from: 64.07625,
                to: 64.08375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['H grease'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        delta: 30.14,
                        assignment: 'CH₂',
                    },
                ],
                from: 30.13625,
                to: 30.14375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['hexamethylbenzene'],
        smiles: 'CC1=C(C(=C(C(=C1C)C)C)C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 132.09,
                        assignment: 'C',
                    },
                ],
                from: 132.08625,
                to: 132.09375,
            },
            {
                signals: [
                    {
                        delta: 16.93,
                        assignment: 'CH₃',
                    },
                ],
                from: 16.92625,
                to: 16.93375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['n-hexane'],
        smiles: 'CCCCCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 14.28,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.27625,
                to: 14.28375,
            },
            {
                signals: [
                    {
                        delta: 23.07,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 23.06625,
                to: 23.07375,
            },
            {
                signals: [
                    {
                        delta: 32.01,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 32.00625,
                to: 32.013749999999995,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['HMDSO'],
        smiles: 'C[Si](C)(C)O[Si](C)(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 1.96,
                        assignment: 'CH₃',
                    },
                ],
                from: 1.95625,
                to: 1.9637499999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['HMPA'],
        smiles: 'CN(C)P(=O)(N(C)C)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 36.99,
                        assignment: 'CH₃',
                    },
                ],
                from: 36.986250000000005,
                to: 36.99375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['imidazole'],
        smiles: 'C1=CN=CN1',
        ranges: [
            {
                signals: [
                    {
                        delta: 135.76,
                        assignment: 'CH(2)',
                    },
                ],
                from: 135.75625,
                to: 135.76375,
            },
            {
                signals: [
                    {
                        delta: 122.16,
                        assignment: 'CH(4,5)',
                    },
                ],
                from: 122.15625,
                to: 122.16375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['methane'],
        smiles: 'C',
        ranges: [
            {
                signals: [
                    {
                        delta: -4.33,
                        assignment: 'CH₄',
                    },
                ],
                from: -4.33375,
                to: -4.32625,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['methanol'],
        smiles: 'CO',
        ranges: [
            {
                signals: [
                    {
                        delta: 50.45,
                        assignment: 'CH₃',
                    },
                ],
                from: 50.446250000000006,
                to: 50.45375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['nitromethane'],
        smiles: 'C[N+](=O)[O-]',
        ranges: [
            {
                signals: [
                    {
                        delta: 63.03,
                        assignment: 'CH₃',
                    },
                ],
                from: 63.026250000000005,
                to: 63.03375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['n-pentane'],
        smiles: 'CCCCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 14.24,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.23625,
                to: 14.24375,
            },
            {
                signals: [
                    {
                        delta: 22.77,
                        assignment: 'CH₂(2,4)',
                    },
                ],
                from: 22.76625,
                to: 22.77375,
            },
            {
                signals: [
                    {
                        delta: 34.57,
                        assignment: 'CH₂(3)',
                    },
                ],
                from: 34.566250000000004,
                to: 34.57375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['propane'],
        smiles: 'CCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 16.63,
                        assignment: 'CH₃',
                    },
                ],
                from: 16.62625,
                to: 16.63375,
            },
            {
                signals: [
                    {
                        delta: 16.63,
                        assignment: 'CH₂',
                    },
                ],
                from: 16.62625,
                to: 16.63375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['2-propanol'],
        smiles: 'CC(O)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 25.43,
                        assignment: 'CH₃',
                    },
                ],
                from: 25.42625,
                to: 25.43375,
            },
            {
                signals: [
                    {
                        delta: 64.67,
                        assignment: 'CH',
                    },
                ],
                from: 64.66625,
                to: 64.67375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['propylene'],
        smiles: 'CC=C',
        ranges: [
            {
                signals: [
                    {
                        delta: 19.47,
                        assignment: 'CH₃',
                    },
                ],
                from: 19.46625,
                to: 19.47375,
            },
            {
                signals: [
                    {
                        delta: 115.7,
                        assignment: 'CH₂',
                    },
                ],
                from: 115.69625,
                to: 115.70375,
            },
            {
                signals: [
                    {
                        delta: 134.21,
                        assignment: 'CH',
                    },
                ],
                from: 134.20625,
                to: 134.21375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['pyridine'],
        smiles: 'C1=CC=NC=C1',
        ranges: [
            {
                signals: [
                    {
                        delta: 150.27,
                        assignment: 'CH(2,6)',
                    },
                ],
                from: 150.26625,
                to: 150.27375,
            },
            {
                signals: [
                    {
                        delta: 124.06,
                        assignment: 'CH(3,5)',
                    },
                ],
                from: 124.05625,
                to: 124.06375,
            },
            {
                signals: [
                    {
                        delta: 136.16,
                        assignment: 'CH(4)',
                    },
                ],
                from: 136.15625,
                to: 136.16375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['pyrrole'],
        smiles: 'C1=CNC=C1',
        ranges: [
            {
                signals: [
                    {
                        delta: 117.93,
                        assignment: 'CH(2,5)',
                    },
                ],
                from: 117.92625000000001,
                to: 117.93375,
            },
            {
                signals: [
                    {
                        delta: 108.02,
                        assignment: 'CH(3,4)',
                    },
                ],
                from: 108.01625,
                to: 108.02374999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['pyrrolidine'],
        smiles: 'C1CCNC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 47.02,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 47.01625000000001,
                to: 47.02375,
            },
            {
                signals: [
                    {
                        delta: 25.83,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 25.826249999999998,
                to: 25.83375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['silicone grease'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        delta: 1.22,
                        assignment: 'CH₃',
                    },
                ],
                from: 1.21625,
                to: 1.22375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['tetrahydrofuran'],
        smiles: 'C1COCC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 68.16,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 68.15625,
                to: 68.16375,
            },
            {
                signals: [
                    {
                        delta: 25.98,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 25.97625,
                to: 25.98375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['toluene'],
        smiles: 'Cc1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        delta: 21.53,
                        assignment: 'CH₃',
                    },
                ],
                from: 21.52625,
                to: 21.53375,
            },
            {
                signals: [
                    {
                        delta: 138.36,
                        assignment: 'C(1)',
                    },
                ],
                from: 138.35625000000002,
                to: 138.36375,
            },
            {
                signals: [
                    {
                        delta: 129.35,
                        assignment: 'CH(2,6)',
                    },
                ],
                from: 129.34625,
                to: 129.35375,
            },
            {
                signals: [
                    {
                        delta: 128.54,
                        assignment: 'CH(3,5)',
                    },
                ],
                from: 128.53625,
                to: 128.54375,
            },
            {
                signals: [
                    {
                        delta: 125.62,
                        assignment: 'CH(4)',
                    },
                ],
                from: 125.61625000000001,
                to: 125.62375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['triethylamine'],
        smiles: 'CCN(CC)CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 12.12,
                        assignment: 'CH₃',
                    },
                ],
                from: 12.116249999999999,
                to: 12.12375,
            },
            {
                signals: [
                    {
                        delta: 46.75,
                        assignment: 'CH₂',
                    },
                ],
                from: 46.74625,
                to: 46.75375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['acetic acid'],
        smiles: 'CC(=O)O',
        ranges: [
            {
                signals: [
                    {
                        delta: 175.99,
                        assignment: 'CO',
                    },
                ],
                from: 175.98625,
                to: 175.99375,
            },
            {
                signals: [
                    {
                        delta: 20.81,
                        assignment: 'CH₃',
                    },
                ],
                from: 20.80625,
                to: 20.81375,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['acetone'],
        smiles: 'CC(=O)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 207.07,
                        assignment: 'CO',
                    },
                ],
                from: 207.06625,
                to: 207.07375,
            },
            {
                signals: [
                    {
                        delta: 30.92,
                        assignment: 'CH₃',
                    },
                ],
                from: 30.91625,
                to: 30.923750000000002,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['acetonitrile'],
        smiles: 'CC#N',
        ranges: [
            {
                signals: [
                    {
                        delta: 116.43,
                        assignment: 'CN',
                    },
                ],
                from: 116.42625000000001,
                to: 116.43375,
            },
            {
                signals: [
                    {
                        delta: 1.89,
                        assignment: 'CH₃',
                    },
                ],
                from: 1.88625,
                to: 1.8937499999999998,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['benzene'],
        smiles: 'c1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        delta: 128.37,
                        assignment: 'CH',
                    },
                ],
                from: 128.36625,
                to: 128.37375,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['tert -butyl alcohol'],
        smiles: 'CC(C)(C)O',
        ranges: [
            {
                signals: [
                    {
                        delta: 69.15,
                        assignment: '(CH₃)₃C',
                    },
                ],
                from: 69.14625000000001,
                to: 69.15375,
            },
            {
                signals: [
                    {
                        delta: 31.25,
                        assignment: '(CH₃)₃C',
                    },
                ],
                from: 31.24625,
                to: 31.25375,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['carbon dioxide'],
        smiles: 'O=C=O',
        ranges: [
            {
                signals: [
                    {
                        delta: 124.99,
                        assignment: 'CO₂',
                    },
                ],
                from: 124.98625,
                to: 124.99374999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['carbon disulfide'],
        smiles: 'S=C=S',
        ranges: [
            {
                signals: [
                    {
                        delta: 192.83,
                        assignment: 'CS₂',
                    },
                ],
                from: 192.82625000000002,
                to: 192.83375,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['carbon tetrachloride'],
        smiles: 'ClC(Cl)(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        delta: 96.34,
                        assignment: 'CCl₄',
                    },
                ],
                from: 96.33625,
                to: 96.34375,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['chloroform'],
        smiles: 'ClC(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        delta: 77.36,
                        assignment: 'CH',
                    },
                ],
                from: 77.35625,
                to: 77.36375,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['18-crown-6'],
        smiles: 'C1COCCOCCOCCOCCOCCO1',
        ranges: [
            {
                signals: [
                    {
                        delta: 70.55,
                        assignment: 'CH₂',
                    },
                ],
                from: 70.54625,
                to: 70.55375,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['cyclohexane'],
        smiles: 'C1CCCCC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 26.94,
                        assignment: 'CH₂',
                    },
                ],
                from: 26.93625,
                to: 26.94375,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['1,2-dichloroethane'],
        smiles: 'ClCCCl',
        ranges: [
            {
                signals: [
                    {
                        delta: 43.5,
                        assignment: 'CH₂',
                    },
                ],
                from: 43.49625,
                to: 43.50375,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['dichloromethane'],
        smiles: 'ClCCl',
        ranges: [
            {
                signals: [
                    {
                        delta: 53.52,
                        assignment: 'CH₂',
                    },
                ],
                from: 53.51625000000001,
                to: 53.52375,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 15.2,
                        assignment: 'CH₃',
                    },
                ],
                from: 15.19625,
                to: 15.20375,
            },
            {
                signals: [
                    {
                        delta: 65.91,
                        assignment: 'CH₂',
                    },
                ],
                from: 65.90625,
                to: 65.91375,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['diglyme'],
        smiles: 'COCCOCCOC',
        ranges: [
            {
                signals: [
                    {
                        delta: 59.01,
                        assignment: 'CH₃',
                    },
                ],
                from: 59.00625,
                to: 59.013749999999995,
            },
            {
                signals: [
                    {
                        delta: 70.51,
                        assignment: 'CH₂',
                    },
                ],
                from: 70.50625000000001,
                to: 70.51375,
            },
            {
                signals: [
                    {
                        delta: 71.9,
                        assignment: 'CH₂',
                    },
                ],
                from: 71.89625000000001,
                to: 71.90375,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['dimethylformamide'],
        smiles: 'C(=O)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 162.62,
                        assignment: 'CH',
                    },
                ],
                from: 162.61625,
                to: 162.62375,
            },
            {
                signals: [
                    {
                        delta: 36.5,
                        assignment: 'CH₃',
                    },
                ],
                from: 36.49625,
                to: 36.50375,
            },
            {
                signals: [
                    {
                        delta: 31.45,
                        assignment: 'CH₃',
                    },
                ],
                from: 31.44625,
                to: 31.45375,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['1,4-dioxane'],
        smiles: 'C1COCCOC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 67.14,
                        assignment: 'CH₂',
                    },
                ],
                from: 67.13625,
                to: 67.14375,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['DME', 'diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 59.08,
                        assignment: 'CH₃',
                    },
                ],
                from: 59.07625,
                to: 59.083749999999995,
            },
            {
                signals: [
                    {
                        delta: 71.84,
                        assignment: 'CH₂',
                    },
                ],
                from: 71.83625,
                to: 71.84375,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['ethane'],
        smiles: 'CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 6.89,
                        assignment: 'CH₃',
                    },
                ],
                from: 6.8862499999999995,
                to: 6.89375,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['ethanol'],
        smiles: 'CCO',
        ranges: [
            {
                signals: [
                    {
                        delta: 18.41,
                        assignment: 'CH₃',
                    },
                ],
                from: 18.40625,
                to: 18.41375,
            },
            {
                signals: [
                    {
                        delta: 58.28,
                        assignment: 'CH₂',
                    },
                ],
                from: 58.276250000000005,
                to: 58.28375,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['ethyl acetate'],
        smiles: 'CC(=O)CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 21.04,
                        assignment: 'CH₃CO',
                    },
                ],
                from: 21.03625,
                to: 21.04375,
            },
            {
                signals: [
                    {
                        delta: 171.36,
                        assignment: 'CO',
                    },
                ],
                from: 171.35625000000002,
                to: 171.36375,
            },
            {
                signals: [
                    {
                        delta: 60.49,
                        assignment: 'CH₂',
                    },
                ],
                from: 60.486250000000005,
                to: 60.49375,
            },
            {
                signals: [
                    {
                        delta: 14.19,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.18625,
                to: 14.19375,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['ethylene'],
        smiles: 'C=C',
        ranges: [
            {
                signals: [
                    {
                        delta: 123.13,
                        assignment: 'CH₂',
                    },
                ],
                from: 123.12625,
                to: 123.13374999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['ethylene glycol'],
        smiles: 'OCCO',
        ranges: [
            {
                signals: [
                    {
                        delta: 63.79,
                        assignment: 'CH₂',
                    },
                ],
                from: 63.78625,
                to: 63.793749999999996,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['H grease'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        delta: 29.71,
                        assignment: 'CH₂',
                    },
                ],
                from: 29.70625,
                to: 29.71375,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['hexamethylbenzene'],
        smiles: 'CC1=C(C(=C(C(=C1C)C)C)C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 132.21,
                        assignment: 'C',
                    },
                ],
                from: 132.20625,
                to: 132.21375,
            },
            {
                signals: [
                    {
                        delta: 16.98,
                        assignment: 'CH₃',
                    },
                ],
                from: 16.97625,
                to: 16.98375,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['n-hexane'],
        smiles: 'CCCCCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 14.14,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.13625,
                to: 14.14375,
            },
            {
                signals: [
                    {
                        delta: 22.7,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 22.69625,
                to: 22.70375,
            },
            {
                signals: [
                    {
                        delta: 31.64,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 31.63625,
                to: 31.64375,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['HMDSO'],
        smiles: 'C[Si](C)(C)O[Si](C)(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 1.97,
                        assignment: 'CH₃',
                    },
                ],
                from: 1.96625,
                to: 1.97375,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['HMPA'],
        smiles: 'CN(C)P(=O)(N(C)C)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 36.87,
                        assignment: 'CH₃',
                    },
                ],
                from: 36.86625,
                to: 36.873749999999994,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['imidazole'],
        smiles: 'C1=CN=CN1',
        ranges: [
            {
                signals: [
                    {
                        delta: 135.38,
                        assignment: 'CH(2)',
                    },
                ],
                from: 135.37625,
                to: 135.38375,
            },
            {
                signals: [
                    {
                        delta: 122,
                        assignment: 'CH(4,5)',
                    },
                ],
                from: 121.99625,
                to: 122.00375,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['methane'],
        smiles: 'C',
        ranges: [
            {
                signals: [
                    {
                        delta: -4.63,
                        assignment: 'CH₄',
                    },
                ],
                from: -4.63375,
                to: -4.62625,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['methanol'],
        smiles: 'CO',
        ranges: [
            {
                signals: [
                    {
                        delta: 50.41,
                        assignment: 'CH₃',
                    },
                ],
                from: 50.40625,
                to: 50.41374999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['nitromethane'],
        smiles: 'C[N+](=O)[O-]',
        ranges: [
            {
                signals: [
                    {
                        delta: 62.5,
                        assignment: 'CH₃',
                    },
                ],
                from: 62.49625,
                to: 62.50375,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['n-pentane'],
        smiles: 'CCCCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 14.08,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.07625,
                to: 14.08375,
            },
            {
                signals: [
                    {
                        delta: 22.38,
                        assignment: 'CH₂(2,4)',
                    },
                ],
                from: 22.37625,
                to: 22.38375,
            },
            {
                signals: [
                    {
                        delta: 34.16,
                        assignment: 'CH₂(3)',
                    },
                ],
                from: 34.15625,
                to: 34.16374999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['propane'],
        smiles: 'CCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 16.63,
                        assignment: 'CH₃',
                    },
                ],
                from: 16.62625,
                to: 16.63375,
            },
            {
                signals: [
                    {
                        delta: 16.37,
                        assignment: 'CH₂',
                    },
                ],
                from: 16.36625,
                to: 16.37375,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['2-propanol'],
        smiles: 'CC(O)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 25.14,
                        assignment: 'CH₃',
                    },
                ],
                from: 25.13625,
                to: 25.14375,
            },
            {
                signals: [
                    {
                        delta: 64.5,
                        assignment: 'CH',
                    },
                ],
                from: 64.49625,
                to: 64.50375,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['propylene'],
        smiles: 'CC=C',
        ranges: [
            {
                signals: [
                    {
                        delta: 19.5,
                        assignment: 'CH₃',
                    },
                ],
                from: 19.49625,
                to: 19.50375,
            },
            {
                signals: [
                    {
                        delta: 115.74,
                        assignment: 'CH₂',
                    },
                ],
                from: 115.73625,
                to: 115.74374999999999,
            },
            {
                signals: [
                    {
                        delta: 133.91,
                        assignment: 'CH',
                    },
                ],
                from: 133.90625,
                to: 133.91375,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['pyridine'],
        smiles: 'C1=CC=NC=C1',
        ranges: [
            {
                signals: [
                    {
                        delta: 149.9,
                        assignment: 'CH(2,6)',
                    },
                ],
                from: 149.89625,
                to: 149.90375,
            },
            {
                signals: [
                    {
                        delta: 123.75,
                        assignment: 'CH(3,5)',
                    },
                ],
                from: 123.74625,
                to: 123.75375,
            },
            {
                signals: [
                    {
                        delta: 135.96,
                        assignment: 'CH(4)',
                    },
                ],
                from: 135.95625,
                to: 135.96375,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['pyrrole'],
        smiles: 'C1=CNC=C1',
        ranges: [
            {
                signals: [
                    {
                        delta: 117.77,
                        assignment: 'CH(2,5)',
                    },
                ],
                from: 117.76625,
                to: 117.77374999999999,
            },
            {
                signals: [
                    {
                        delta: 107.98,
                        assignment: 'CH(3,4)',
                    },
                ],
                from: 107.97625000000001,
                to: 107.98375,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['pyrrolidine'],
        smiles: 'C1CCNC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 46.93,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 46.92625,
                to: 46.933749999999996,
            },
            {
                signals: [
                    {
                        delta: 25.56,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 25.55625,
                to: 25.56375,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['silicone grease'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        delta: 1.19,
                        assignment: 'CH₃',
                    },
                ],
                from: 1.18625,
                to: 1.1937499999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['tetrahydrofuran'],
        smiles: 'C1COCC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 67.97,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 67.96625,
                to: 67.97375,
            },
            {
                signals: [
                    {
                        delta: 25.62,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 25.61625,
                to: 25.62375,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['toluene'],
        smiles: 'Cc1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        delta: 21.46,
                        assignment: 'CH₃',
                    },
                ],
                from: 21.45625,
                to: 21.46375,
            },
            {
                signals: [
                    {
                        delta: 137.89,
                        assignment: 'C(1)',
                    },
                ],
                from: 137.88625,
                to: 137.89374999999998,
            },
            {
                signals: [
                    {
                        delta: 129.07,
                        assignment: 'CH(2,6)',
                    },
                ],
                from: 129.06625,
                to: 129.07375,
            },
            {
                signals: [
                    {
                        delta: 128.26,
                        assignment: 'CH(3,5)',
                    },
                ],
                from: 128.25625,
                to: 128.26375,
            },
            {
                signals: [
                    {
                        delta: 125.33,
                        assignment: 'CH(4)',
                    },
                ],
                from: 125.32625,
                to: 125.33375,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['triethylamine'],
        smiles: 'CCN(CC)CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 11.61,
                        assignment: 'CH₃',
                    },
                ],
                from: 11.60625,
                to: 11.61375,
            },
            {
                signals: [
                    {
                        delta: 46.25,
                        assignment: 'CH₂',
                    },
                ],
                from: 46.24625,
                to: 46.25375,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['acetic acid'],
        smiles: 'CC(=O)O',
        ranges: [
            {
                signals: [
                    {
                        delta: 175.3,
                        assignment: 'CO',
                    },
                ],
                from: 175.29625000000001,
                to: 175.30375,
            },
            {
                signals: [
                    {
                        delta: 20.27,
                        assignment: 'CH₃',
                    },
                ],
                from: 20.26625,
                to: 20.27375,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['acetone'],
        smiles: 'CC(=O)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 204,
                        assignment: 'CO',
                    },
                ],
                from: 203.99625,
                to: 204.00375,
            },
            {
                signals: [
                    {
                        delta: 30.03,
                        assignment: 'CH₃',
                    },
                ],
                from: 30.02625,
                to: 30.03375,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['acetonitrile'],
        smiles: 'CC#N',
        ranges: [
            {
                signals: [
                    {
                        delta: 115.76,
                        assignment: 'CN',
                    },
                ],
                from: 115.75625000000001,
                to: 115.76375,
            },
            {
                signals: [
                    {
                        delta: 0.03,
                        assignment: 'CH₃',
                    },
                ],
                from: 0.02625,
                to: 0.03375,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['benzene'],
        smiles: 'c1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        delta: 128.57,
                        assignment: 'CH',
                    },
                ],
                from: 128.56625,
                to: 128.57375,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['tert -butyl alcohol'],
        smiles: 'CC(C)(C)O',
        ranges: [
            {
                signals: [
                    {
                        delta: 68.12,
                        assignment: '(CH₃)₃C',
                    },
                ],
                from: 68.11625000000001,
                to: 68.12375,
            },
            {
                signals: [
                    {
                        delta: 30.49,
                        assignment: '(CH₃)₃C',
                    },
                ],
                from: 30.48625,
                to: 30.49375,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['carbon dioxide'],
        smiles: 'O=C=O',
        ranges: [
            {
                signals: [
                    {
                        delta: 124.86,
                        assignment: 'CO₂',
                    },
                ],
                from: 124.85625,
                to: 124.86375,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['carbon disulfide'],
        smiles: 'S=C=S',
        ranges: [
            {
                signals: [
                    {
                        delta: 192.71,
                        assignment: 'CS₂',
                    },
                ],
                from: 192.70625,
                to: 192.71375,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['carbon tetrachloride'],
        smiles: 'ClC(Cl)(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        delta: 96.57,
                        assignment: 'CCl₄',
                    },
                ],
                from: 96.56625,
                to: 96.57374999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['chloroform'],
        smiles: 'ClC(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        delta: 77.89,
                        assignment: 'CH',
                    },
                ],
                from: 77.88625,
                to: 77.89375,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['18-crown-6'],
        smiles: 'C1COCCOCCOCCOCCOCCO1',
        ranges: [
            {
                signals: [
                    {
                        delta: 70.86,
                        assignment: 'CH₂',
                    },
                ],
                from: 70.85625,
                to: 70.86375,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['cyclohexane'],
        smiles: 'C1CCCCC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 27.31,
                        assignment: 'CH₂',
                    },
                ],
                from: 27.30625,
                to: 27.31375,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['1,2-dichloroethane'],
        smiles: 'ClCCCl',
        ranges: [
            {
                signals: [
                    {
                        delta: 43.4,
                        assignment: 'CH₂',
                    },
                ],
                from: 43.39625,
                to: 43.403749999999995,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['dichloromethane'],
        smiles: 'ClCCl',
        ranges: [
            {
                signals: [
                    {
                        delta: 53.47,
                        assignment: 'CH₂',
                    },
                ],
                from: 53.46625,
                to: 53.473749999999995,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 15.47,
                        assignment: 'CH₃',
                    },
                ],
                from: 15.46625,
                to: 15.47375,
            },
            {
                signals: [
                    {
                        delta: 65.94,
                        assignment: 'CH₂',
                    },
                ],
                from: 65.93625,
                to: 65.94375,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['diglyme'],
        smiles: 'COCCOCCOC',
        ranges: [
            {
                signals: [
                    {
                        delta: 58.62,
                        assignment: 'CH₃',
                    },
                ],
                from: 58.61625,
                to: 58.623749999999994,
            },
            {
                signals: [
                    {
                        delta: 70.92,
                        assignment: 'CH₂',
                    },
                ],
                from: 70.91625,
                to: 70.92375,
            },
            {
                signals: [
                    {
                        delta: 72.39,
                        assignment: 'CH₂',
                    },
                ],
                from: 72.38625,
                to: 72.39375,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['dimethylformamide'],
        smiles: 'C(=O)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 161.93,
                        assignment: 'CH',
                    },
                ],
                from: 161.92625,
                to: 161.93375,
            },
            {
                signals: [
                    {
                        delta: 35.22,
                        assignment: 'CH₃',
                    },
                ],
                from: 35.21625,
                to: 35.223749999999995,
            },
            {
                signals: [
                    {
                        delta: 30.64,
                        assignment: 'CH₃',
                    },
                ],
                from: 30.63625,
                to: 30.64375,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['1,4-dioxane'],
        smiles: 'C1COCCOC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 67.17,
                        assignment: 'CH₂',
                    },
                ],
                from: 67.16625,
                to: 67.17375,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['DME', 'diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 58.63,
                        assignment: 'CH₃',
                    },
                ],
                from: 58.626250000000006,
                to: 58.63375,
            },
            {
                signals: [
                    {
                        delta: 72.25,
                        assignment: 'CH₂',
                    },
                ],
                from: 72.24625,
                to: 72.25375,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['ethane'],
        smiles: 'CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 6.94,
                        assignment: 'CH₃',
                    },
                ],
                from: 6.93625,
                to: 6.9437500000000005,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['ethanol'],
        smiles: 'CCO',
        ranges: [
            {
                signals: [
                    {
                        delta: 18.78,
                        assignment: 'CH₃',
                    },
                ],
                from: 18.77625,
                to: 18.78375,
            },
            {
                signals: [
                    {
                        delta: 57.81,
                        assignment: 'CH₂',
                    },
                ],
                from: 57.806250000000006,
                to: 57.81375,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['ethyl acetate'],
        smiles: 'CC(=O)CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 20.46,
                        assignment: 'CH₃CO',
                    },
                ],
                from: 20.45625,
                to: 20.46375,
            },
            {
                signals: [
                    {
                        delta: 170.02,
                        assignment: 'CO',
                    },
                ],
                from: 170.01625,
                to: 170.02375,
            },
            {
                signals: [
                    {
                        delta: 60.08,
                        assignment: 'CH₂',
                    },
                ],
                from: 60.07625,
                to: 60.083749999999995,
            },
            {
                signals: [
                    {
                        delta: 14.23,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.22625,
                to: 14.23375,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['ethylene'],
        smiles: 'C=C',
        ranges: [
            {
                signals: [
                    {
                        delta: 122.92,
                        assignment: 'CH₂',
                    },
                ],
                from: 122.91625,
                to: 122.92375,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['ethylene glycol'],
        smiles: 'OCCO',
        ranges: [
            {
                signals: [
                    {
                        delta: 64.29,
                        assignment: 'CH₂',
                    },
                ],
                from: 64.28625000000001,
                to: 64.29375,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['H grease'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        delta: 30.31,
                        assignment: 'CH₂',
                    },
                ],
                from: 30.30625,
                to: 30.31375,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['hexamethylbenzene'],
        smiles: 'CC1=C(C(=C(C(=C1C)C)C)C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 131.72,
                        assignment: 'C',
                    },
                ],
                from: 131.71625,
                to: 131.72375,
            },
            {
                signals: [
                    {
                        delta: 16.84,
                        assignment: 'CH₃',
                    },
                ],
                from: 16.83625,
                to: 16.84375,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['n-hexane'],
        smiles: 'CCCCCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 14.34,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.33625,
                to: 14.34375,
            },
            {
                signals: [
                    {
                        delta: 23.12,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 23.11625,
                to: 23.12375,
            },
            {
                signals: [
                    {
                        delta: 32.06,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 32.056250000000006,
                to: 32.06375,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['HMDSO'],
        smiles: 'C[Si](C)(C)O[Si](C)(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 1.99,
                        assignment: 'CH₃',
                    },
                ],
                from: 1.98625,
                to: 1.99375,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['HMPA'],
        smiles: 'CN(C)P(=O)(N(C)C)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 36.8,
                        assignment: 'CH₃',
                    },
                ],
                from: 36.79625,
                to: 36.803749999999994,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['imidazole'],
        smiles: 'C1=CN=CN1',
        ranges: [
            {
                signals: [
                    {
                        delta: 135.57,
                        assignment: 'CH(2)',
                    },
                ],
                from: 135.56625,
                to: 135.57375,
            },
            {
                signals: [
                    {
                        delta: 122.13,
                        assignment: 'CH(4,5)',
                    },
                ],
                from: 122.12625,
                to: 122.13374999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['methane'],
        smiles: 'C',
        ranges: [
            {
                signals: [
                    {
                        delta: -4.34,
                        assignment: 'CH₄',
                    },
                ],
                from: -4.34375,
                to: -4.33625,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['methanol'],
        smiles: 'CO',
        ranges: [
            {
                signals: [
                    {
                        delta: 49.9,
                        assignment: 'CH₃',
                    },
                ],
                from: 49.89625,
                to: 49.903749999999995,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['nitromethane'],
        smiles: 'C[N+](=O)[O-]',
        ranges: [
            {
                signals: [
                    {
                        delta: 61.14,
                        assignment: 'CH₃',
                    },
                ],
                from: 61.136250000000004,
                to: 61.14375,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['n-pentane'],
        smiles: 'CCCCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 14.27,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.26625,
                to: 14.27375,
            },
            {
                signals: [
                    {
                        delta: 22.79,
                        assignment: 'CH₂(2,4)',
                    },
                ],
                from: 22.78625,
                to: 22.79375,
            },
            {
                signals: [
                    {
                        delta: 34.54,
                        assignment: 'CH₂(3)',
                    },
                ],
                from: 34.53625,
                to: 34.543749999999996,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['propane'],
        smiles: 'CCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 16.65,
                        assignment: 'CH₃',
                    },
                ],
                from: 16.64625,
                to: 16.65375,
            },
            {
                signals: [
                    {
                        delta: 16.63,
                        assignment: 'CH₂',
                    },
                ],
                from: 16.62625,
                to: 16.63375,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['2-propanol'],
        smiles: 'CC(O)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 25.24,
                        assignment: 'CH₃',
                    },
                ],
                from: 25.23625,
                to: 25.24375,
            },
            {
                signals: [
                    {
                        delta: 64.12,
                        assignment: 'CH',
                    },
                ],
                from: 64.11625000000001,
                to: 64.12375,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['propylene'],
        smiles: 'CC=C',
        ranges: [
            {
                signals: [
                    {
                        delta: 19.32,
                        assignment: 'CH₃',
                    },
                ],
                from: 19.31625,
                to: 19.32375,
            },
            {
                signals: [
                    {
                        delta: 115.89,
                        assignment: 'CH₂',
                    },
                ],
                from: 115.88625,
                to: 115.89375,
            },
            {
                signals: [
                    {
                        delta: 133.61,
                        assignment: 'CH',
                    },
                ],
                from: 133.60625000000002,
                to: 133.61375,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['pyridine'],
        smiles: 'C1=CC=NC=C1',
        ranges: [
            {
                signals: [
                    {
                        delta: 150.25,
                        assignment: 'CH(2,6)',
                    },
                ],
                from: 150.24625,
                to: 150.25375,
            },
            {
                signals: [
                    {
                        delta: 123.46,
                        assignment: 'CH(3,5)',
                    },
                ],
                from: 123.45625,
                to: 123.46374999999999,
            },
            {
                signals: [
                    {
                        delta: 135.17,
                        assignment: 'CH(4)',
                    },
                ],
                from: 135.16625,
                to: 135.17374999999998,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['pyrrole'],
        smiles: 'C1=CNC=C1',
        ranges: [
            {
                signals: [
                    {
                        delta: 117.61,
                        assignment: 'CH(2,5)',
                    },
                ],
                from: 117.60625,
                to: 117.61375,
            },
            {
                signals: [
                    {
                        delta: 108.15,
                        assignment: 'CH(3,4)',
                    },
                ],
                from: 108.14625000000001,
                to: 108.15375,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['pyrrolidine'],
        smiles: 'C1CCNC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 47.12,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 47.11625,
                to: 47.123749999999994,
            },
            {
                signals: [
                    {
                        delta: 25.75,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 25.74625,
                to: 25.75375,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['silicone grease'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        delta: 1.37,
                        assignment: 'CH₃',
                    },
                ],
                from: 1.3662500000000002,
                to: 1.37375,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['tetrahydrofuran'],
        smiles: 'C1COCC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 67.75,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 67.74625,
                to: 67.75375,
            },
            {
                signals: [
                    {
                        delta: 25.79,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 25.78625,
                to: 25.79375,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['toluene'],
        smiles: 'Cc1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        delta: 21.37,
                        assignment: 'CH₃',
                    },
                ],
                from: 21.36625,
                to: 21.37375,
            },
            {
                signals: [
                    {
                        delta: 137.84,
                        assignment: 'C(1)',
                    },
                ],
                from: 137.83625,
                to: 137.84375,
            },
            {
                signals: [
                    {
                        delta: 129.33,
                        assignment: 'CH(2,6)',
                    },
                ],
                from: 129.32625000000002,
                to: 129.33375,
            },
            {
                signals: [
                    {
                        delta: 128.51,
                        assignment: 'CH(3,5)',
                    },
                ],
                from: 128.50625,
                to: 128.51375,
            },
            {
                signals: [
                    {
                        delta: 125.66,
                        assignment: 'CH(4)',
                    },
                ],
                from: 125.65625,
                to: 125.66375,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['triethylamine'],
        smiles: 'CCN(CC)CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 12.39,
                        assignment: 'CH₃',
                    },
                ],
                from: 12.38625,
                to: 12.39375,
            },
            {
                signals: [
                    {
                        delta: 46.82,
                        assignment: 'CH₂',
                    },
                ],
                from: 46.816250000000004,
                to: 46.82375,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['acetic acid'],
        smiles: 'CC(=O)O',
        ranges: [
            {
                signals: [
                    {
                        delta: 175.82,
                        assignment: 'CO',
                    },
                ],
                from: 175.81625,
                to: 175.82375,
            },
            {
                signals: [
                    {
                        delta: 20.37,
                        assignment: 'CH₃',
                    },
                ],
                from: 20.36625,
                to: 20.37375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['acetone'],
        smiles: 'CC(=O)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 204.43,
                        assignment: 'CO',
                    },
                ],
                from: 204.42625,
                to: 204.43375,
            },
            {
                signals: [
                    {
                        delta: 30.14,
                        assignment: 'CH₃',
                    },
                ],
                from: 30.13625,
                to: 30.14375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['acetonitrile'],
        smiles: 'CC#N',
        ranges: [
            {
                signals: [
                    {
                        delta: 116.02,
                        assignment: 'CN',
                    },
                ],
                from: 116.01625,
                to: 116.02374999999999,
            },
            {
                signals: [
                    {
                        delta: 0.2,
                        assignment: 'CH₃',
                    },
                ],
                from: 0.19625,
                to: 0.20375000000000001,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['benzene'],
        smiles: 'c1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        delta: 128.62,
                        assignment: 'CH',
                    },
                ],
                from: 128.61625,
                to: 128.62375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['tert -butyl alcohol'],
        smiles: 'CC(C)(C)O',
        ranges: [
            {
                signals: [
                    {
                        delta: 68.19,
                        assignment: '(CH₃)₃C',
                    },
                ],
                from: 68.18625,
                to: 68.19375,
            },
            {
                signals: [
                    {
                        delta: 30.47,
                        assignment: '(CH₃)₃C',
                    },
                ],
                from: 30.46625,
                to: 30.47375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['carbon dioxide'],
        smiles: 'O=C=O',
        ranges: [
            {
                signals: [
                    {
                        delta: 124.76,
                        assignment: 'CO₂',
                    },
                ],
                from: 124.75625000000001,
                to: 124.76375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['carbon disulfide'],
        smiles: 'S=C=S',
        ranges: [
            {
                signals: [
                    {
                        delta: 192.69,
                        assignment: 'CS₂',
                    },
                ],
                from: 192.68625,
                to: 192.69375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['carbon tetrachloride'],
        smiles: 'ClC(Cl)(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        delta: 96.44,
                        assignment: 'CCl₄',
                    },
                ],
                from: 96.43625,
                to: 96.44375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['chloroform'],
        smiles: 'ClC(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        delta: 77.79,
                        assignment: 'CH',
                    },
                ],
                from: 77.78625000000001,
                to: 77.79375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['18-crown-6'],
        smiles: 'C1COCCOCCOCCOCCOCCO1',
        ranges: [
            {
                signals: [
                    {
                        delta: 70.59,
                        assignment: 'CH₂',
                    },
                ],
                from: 70.58625,
                to: 70.59375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['cyclohexane'],
        smiles: 'C1CCCCC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 27.23,
                        assignment: 'CH₂',
                    },
                ],
                from: 27.22625,
                to: 27.23375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['1,2-dichloroethane'],
        smiles: 'ClCCCl',
        ranges: [
            {
                signals: [
                    {
                        delta: 43.59,
                        assignment: 'CH₂',
                    },
                ],
                from: 43.58625000000001,
                to: 43.59375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['dichloromethane'],
        smiles: 'ClCCl',
        ranges: [
            {
                signals: [
                    {
                        delta: 53.46,
                        assignment: 'CH₂',
                    },
                ],
                from: 53.456250000000004,
                to: 53.46375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 15.46,
                        assignment: 'CH₃',
                    },
                ],
                from: 15.45625,
                to: 15.463750000000001,
            },
            {
                signals: [
                    {
                        delta: 65.94,
                        assignment: 'CH₂',
                    },
                ],
                from: 65.93625,
                to: 65.94375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['diglyme'],
        smiles: 'COCCOCCOC',
        ranges: [
            {
                signals: [
                    {
                        delta: 58.66,
                        assignment: 'CH₃',
                    },
                ],
                from: 58.65625,
                to: 58.66374999999999,
            },
            {
                signals: [
                    {
                        delta: 70.87,
                        assignment: 'CH₂',
                    },
                ],
                from: 70.86625000000001,
                to: 70.87375,
            },
            {
                signals: [
                    {
                        delta: 72.35,
                        assignment: 'CH₂',
                    },
                ],
                from: 72.34625,
                to: 72.35374999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['dimethylformamide'],
        smiles: 'C(=O)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 162.13,
                        assignment: 'CH',
                    },
                ],
                from: 162.12625,
                to: 162.13375,
            },
            {
                signals: [
                    {
                        delta: 35.25,
                        assignment: 'CH₃',
                    },
                ],
                from: 35.24625,
                to: 35.25375,
            },
            {
                signals: [
                    {
                        delta: 30.72,
                        assignment: 'CH₃',
                    },
                ],
                from: 30.71625,
                to: 30.72375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['1,4-dioxane'],
        smiles: 'C1COCCOC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 67.16,
                        assignment: 'CH₂',
                    },
                ],
                from: 67.15625,
                to: 67.16375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['DME', 'diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 58.68,
                        assignment: 'CH₃',
                    },
                ],
                from: 58.67625,
                to: 58.683749999999996,
            },
            {
                signals: [
                    {
                        delta: 72.21,
                        assignment: 'CH₂',
                    },
                ],
                from: 72.20625,
                to: 72.21374999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['ethane'],
        smiles: 'CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 6.96,
                        assignment: 'CH₃',
                    },
                ],
                from: 6.95625,
                to: 6.96375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['ethanol'],
        smiles: 'CCO',
        ranges: [
            {
                signals: [
                    {
                        delta: 18.72,
                        assignment: 'CH₃',
                    },
                ],
                from: 18.71625,
                to: 18.72375,
            },
            {
                signals: [
                    {
                        delta: 57.86,
                        assignment: 'CH₂',
                    },
                ],
                from: 57.85625,
                to: 57.863749999999996,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['ethyl acetate'],
        smiles: 'CC(=O)CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 20.56,
                        assignment: 'CH₃CO',
                    },
                ],
                from: 20.55625,
                to: 20.56375,
            },
            {
                signals: [
                    {
                        delta: 170.44,
                        assignment: 'CO',
                    },
                ],
                from: 170.43625,
                to: 170.44375,
            },
            {
                signals: [
                    {
                        delta: 60.21,
                        assignment: 'CH₂',
                    },
                ],
                from: 60.206250000000004,
                to: 60.21375,
            },
            {
                signals: [
                    {
                        delta: 14.19,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.18625,
                to: 14.19375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['ethylene'],
        smiles: 'C=C',
        ranges: [
            {
                signals: [
                    {
                        delta: 122.96,
                        assignment: 'CH₂',
                    },
                ],
                from: 122.95625,
                to: 122.96374999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['ethylene glycol'],
        smiles: 'OCCO',
        ranges: [
            {
                signals: [
                    {
                        delta: 64.34,
                        assignment: 'CH₂',
                    },
                ],
                from: 64.33625,
                to: 64.34375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['H grease'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        delta: 30.22,
                        assignment: 'CH₂',
                    },
                ],
                from: 30.21625,
                to: 30.22375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['hexamethylbenzene'],
        smiles: 'CC1=C(C(=C(C(=C1C)C)C)C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 131.79,
                        assignment: 'C',
                    },
                ],
                from: 131.78625,
                to: 131.79375,
            },
            {
                signals: [
                    {
                        delta: 16.95,
                        assignment: 'CH₃',
                    },
                ],
                from: 16.94625,
                to: 16.95375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['n-hexane'],
        smiles: 'CCCCCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 14.32,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.31625,
                to: 14.32375,
            },
            {
                signals: [
                    {
                        delta: 23.04,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 23.03625,
                to: 23.04375,
            },
            {
                signals: [
                    {
                        delta: 31.96,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 31.95625,
                to: 31.96375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['HMDSO'],
        smiles: 'C[Si](C)(C)O[Si](C)(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 2.05,
                        assignment: 'CH₃',
                    },
                ],
                from: 2.0462499999999997,
                to: 2.05375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['HMPA'],
        smiles: 'CN(C)P(=O)(N(C)C)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 36.88,
                        assignment: 'CH₃',
                    },
                ],
                from: 36.876250000000006,
                to: 36.88375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['imidazole'],
        smiles: 'C1=CN=CN1',
        ranges: [
            {
                signals: [
                    {
                        delta: 135.76,
                        assignment: 'CH(2)',
                    },
                ],
                from: 135.75625,
                to: 135.76375,
            },
            {
                signals: [
                    {
                        delta: 122.16,
                        assignment: 'CH(4,5)',
                    },
                ],
                from: 122.15625,
                to: 122.16375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['methane'],
        smiles: 'C',
        ranges: [
            {
                signals: [
                    {
                        delta: -4.29,
                        assignment: 'CH₄',
                    },
                ],
                from: -4.29375,
                to: -4.28625,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['methanol'],
        smiles: 'CO',
        ranges: [
            {
                signals: [
                    {
                        delta: 49.97,
                        assignment: 'CH₃',
                    },
                ],
                from: 49.96625,
                to: 49.973749999999995,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['nitromethane'],
        smiles: 'C[N+](=O)[O-]',
        ranges: [
            {
                signals: [
                    {
                        delta: 61.16,
                        assignment: 'CH₃',
                    },
                ],
                from: 61.15625,
                to: 61.16374999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['n-pentane'],
        smiles: 'CCCCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 14.25,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.24625,
                to: 14.25375,
            },
            {
                signals: [
                    {
                        delta: 22.72,
                        assignment: 'CH₂(2,4)',
                    },
                ],
                from: 22.71625,
                to: 22.72375,
            },
            {
                signals: [
                    {
                        delta: 34.45,
                        assignment: 'CH₂(3)',
                    },
                ],
                from: 34.446250000000006,
                to: 34.45375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['propane'],
        smiles: 'CCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 16.66,
                        assignment: 'CH₃',
                    },
                ],
                from: 16.65625,
                to: 16.66375,
            },
            {
                signals: [
                    {
                        delta: 16.6,
                        assignment: 'CH₂',
                    },
                ],
                from: 16.59625,
                to: 16.60375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['2-propanol'],
        smiles: 'CC(O)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 25.18,
                        assignment: 'CH₃',
                    },
                ],
                from: 25.17625,
                to: 25.18375,
            },
            {
                signals: [
                    {
                        delta: 64.23,
                        assignment: 'CH',
                    },
                ],
                from: 64.22625000000001,
                to: 64.23375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['propylene'],
        smiles: 'CC=C',
        ranges: [
            {
                signals: [
                    {
                        delta: 19.38,
                        assignment: 'CH₃',
                    },
                ],
                from: 19.37625,
                to: 19.38375,
            },
            {
                signals: [
                    {
                        delta: 115.92,
                        assignment: 'CH₂',
                    },
                ],
                from: 115.91625,
                to: 115.92375,
            },
            {
                signals: [
                    {
                        delta: 133.69,
                        assignment: 'CH',
                    },
                ],
                from: 133.68625,
                to: 133.69375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['pyridine'],
        smiles: 'C1=CC=NC=C1',
        ranges: [
            {
                signals: [
                    {
                        delta: 150.27,
                        assignment: 'CH(2,6)',
                    },
                ],
                from: 150.26625,
                to: 150.27375,
            },
            {
                signals: [
                    {
                        delta: 123.58,
                        assignment: 'CH(3,5)',
                    },
                ],
                from: 123.57625,
                to: 123.58375,
            },
            {
                signals: [
                    {
                        delta: 135.28,
                        assignment: 'CH(4)',
                    },
                ],
                from: 135.27625,
                to: 135.28375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['pyrrole'],
        smiles: 'C1=CNC=C1',
        ranges: [
            {
                signals: [
                    {
                        delta: 117.78,
                        assignment: 'CH(2,5)',
                    },
                ],
                from: 117.77625,
                to: 117.78375,
            },
            {
                signals: [
                    {
                        delta: 108.21,
                        assignment: 'CH(3,4)',
                    },
                ],
                from: 108.20625,
                to: 108.21374999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['pyrrolidine'],
        smiles: 'C1CCNC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 46.86,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 46.85625,
                to: 46.863749999999996,
            },
            {
                signals: [
                    {
                        delta: 25.65,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 25.64625,
                to: 25.65375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['silicone grease'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        delta: 1.38,
                        assignment: 'CH₃',
                    },
                ],
                from: 1.37625,
                to: 1.3837499999999998,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['tetrahydrofuran'],
        smiles: 'C1COCC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 67.8,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 67.79625,
                to: 67.80375,
            },
            {
                signals: [
                    {
                        delta: 25.72,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 25.71625,
                to: 25.72375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['toluene'],
        smiles: 'Cc1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        delta: 21.1,
                        assignment: 'CH₃',
                    },
                ],
                from: 21.09625,
                to: 21.10375,
            },
            {
                signals: [
                    {
                        delta: 137.91,
                        assignment: 'C(1)',
                    },
                ],
                from: 137.90625,
                to: 137.91375,
            },
            {
                signals: [
                    {
                        delta: 129.33,
                        assignment: 'CH(2,6)',
                    },
                ],
                from: 129.32625000000002,
                to: 129.33375,
            },
            {
                signals: [
                    {
                        delta: 128.56,
                        assignment: 'CH(3,5)',
                    },
                ],
                from: 128.55625,
                to: 128.56375,
            },
            {
                signals: [
                    {
                        delta: 125.68,
                        assignment: 'CH(4)',
                    },
                ],
                from: 125.67625000000001,
                to: 125.68375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['triethylamine'],
        smiles: 'CCN(CC)CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 12.35,
                        assignment: 'CH₃',
                    },
                ],
                from: 12.34625,
                to: 12.35375,
            },
            {
                signals: [
                    {
                        delta: 46.77,
                        assignment: 'CH₂',
                    },
                ],
                from: 46.76625000000001,
                to: 46.77375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['acetic acid'],
        smiles: 'CC(=O)O',
        ranges: [
            {
                signals: [
                    {
                        delta: 175.67,
                        assignment: 'CO',
                    },
                ],
                from: 175.66625,
                to: 175.67374999999998,
            },
            {
                signals: [
                    {
                        delta: 20.4,
                        assignment: 'CH₃',
                    },
                ],
                from: 20.39625,
                to: 20.40375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['acetone'],
        smiles: 'CC(=O)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 204.83,
                        assignment: 'CO',
                    },
                ],
                from: 204.82625000000002,
                to: 204.83375,
            },
            {
                signals: [
                    {
                        delta: 30.12,
                        assignment: 'CH₃',
                    },
                ],
                from: 30.11625,
                to: 30.12375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['acetonitrile'],
        smiles: 'CC#N',
        ranges: [
            {
                signals: [
                    {
                        delta: 115.93,
                        assignment: 'CN',
                    },
                ],
                from: 115.92625000000001,
                to: 115.93375,
            },
            {
                signals: [
                    {
                        delta: 0.63,
                        assignment: 'CH₃',
                    },
                ],
                from: 0.62625,
                to: 0.63375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['benzene'],
        smiles: 'c1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        delta: 128.38,
                        assignment: 'CH',
                    },
                ],
                from: 128.37625,
                to: 128.38375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['tert -butyl alcohol'],
        smiles: 'CC(C)(C)O',
        ranges: [
            {
                signals: [
                    {
                        delta: 68.19,
                        assignment: '(CH₃)₃C',
                    },
                ],
                from: 68.18625,
                to: 68.19375,
            },
            {
                signals: [
                    {
                        delta: 31.13,
                        assignment: '(CH₃)₃C',
                    },
                ],
                from: 31.12625,
                to: 31.13375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['carbon dioxide'],
        smiles: 'O=C=O',
        ranges: [
            {
                signals: [
                    {
                        delta: 126.08,
                        assignment: 'CO₂',
                    },
                ],
                from: 126.07625,
                to: 126.08375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['carbon disulfide'],
        smiles: 'S=C=S',
        ranges: [
            {
                signals: [
                    {
                        delta: 192.49,
                        assignment: 'CS₂',
                    },
                ],
                from: 192.48625,
                to: 192.49375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['carbon tetrachloride'],
        smiles: 'ClC(Cl)(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        delta: 96.38,
                        assignment: 'CCl₄',
                    },
                ],
                from: 96.37625,
                to: 96.38374999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['chloroform'],
        smiles: 'ClC(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        delta: 77.67,
                        assignment: 'CH',
                    },
                ],
                from: 77.66625,
                to: 77.67375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['18-crown-6'],
        smiles: 'C1COCCOCCOCCOCCOCCO1',
        ranges: [
            {
                signals: [
                    {
                        delta: 70.55,
                        assignment: 'CH₂',
                    },
                ],
                from: 70.54625,
                to: 70.55375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['cyclohexane'],
        smiles: 'C1CCCCC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 26.99,
                        assignment: 'CH₂',
                    },
                ],
                from: 26.98625,
                to: 26.99375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['1,2-dichloroethane'],
        smiles: 'ClCCCl',
        ranges: [
            {
                signals: [
                    {
                        delta: 43.6,
                        assignment: 'CH₂',
                    },
                ],
                from: 43.596250000000005,
                to: 43.60375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['dichloromethane'],
        smiles: 'ClCCl',
        ranges: [
            {
                signals: [
                    {
                        delta: 53.54,
                        assignment: 'CH₂',
                    },
                ],
                from: 53.53625,
                to: 53.543749999999996,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 15.35,
                        assignment: 'CH₃',
                    },
                ],
                from: 15.34625,
                to: 15.35375,
            },
            {
                signals: [
                    {
                        delta: 65.79,
                        assignment: 'CH₂',
                    },
                ],
                from: 65.78625000000001,
                to: 65.79375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['diglyme'],
        smiles: 'COCCOCCOC',
        ranges: [
            {
                signals: [
                    {
                        delta: 58.42,
                        assignment: 'CH₃',
                    },
                ],
                from: 58.416250000000005,
                to: 58.42375,
            },
            {
                signals: [
                    {
                        delta: 70.56,
                        assignment: 'CH₂',
                    },
                ],
                from: 70.55625,
                to: 70.56375,
            },
            {
                signals: [
                    {
                        delta: 72.07,
                        assignment: 'CH₂',
                    },
                ],
                from: 72.06625,
                to: 72.07374999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['dimethylformamide'],
        smiles: 'C(=O)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 162.01,
                        assignment: 'CH',
                    },
                ],
                from: 162.00625,
                to: 162.01375,
            },
            {
                signals: [
                    {
                        delta: 35.45,
                        assignment: 'CH₃',
                    },
                ],
                from: 35.446250000000006,
                to: 35.45375,
            },
            {
                signals: [
                    {
                        delta: 30.71,
                        assignment: 'CH₃',
                    },
                ],
                from: 30.70625,
                to: 30.71375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['1,4-dioxane'],
        smiles: 'C1COCCOC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 66.95,
                        assignment: 'CH₂',
                    },
                ],
                from: 66.94625,
                to: 66.95375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['DME', 'diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 58.31,
                        assignment: 'CH₃',
                    },
                ],
                from: 58.306250000000006,
                to: 58.31375,
            },
            {
                signals: [
                    {
                        delta: 71.81,
                        assignment: 'CH₂',
                    },
                ],
                from: 71.80625,
                to: 71.81375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['ethane'],
        smiles: 'CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 6.91,
                        assignment: 'CH₃',
                    },
                ],
                from: 6.90625,
                to: 6.91375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['ethanol'],
        smiles: 'CCO',
        ranges: [
            {
                signals: [
                    {
                        delta: 18.55,
                        assignment: 'CH₃',
                    },
                ],
                from: 18.54625,
                to: 18.55375,
            },
            {
                signals: [
                    {
                        delta: 57.63,
                        assignment: 'CH₂',
                    },
                ],
                from: 57.626250000000006,
                to: 57.63375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['ethyl acetate'],
        smiles: 'CC(=O)CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 20.5,
                        assignment: 'CH₃CO',
                    },
                ],
                from: 20.49625,
                to: 20.50375,
            },
            {
                signals: [
                    {
                        delta: 170.2,
                        assignment: 'CO',
                    },
                ],
                from: 170.19625,
                to: 170.20374999999999,
            },
            {
                signals: [
                    {
                        delta: 60.06,
                        assignment: 'CH₂',
                    },
                ],
                from: 60.056250000000006,
                to: 60.06375,
            },
            {
                signals: [
                    {
                        delta: 14.07,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.06625,
                to: 14.07375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['ethylene'],
        smiles: 'C=C',
        ranges: [
            {
                signals: [
                    {
                        delta: 122.95,
                        assignment: 'CH₂',
                    },
                ],
                from: 122.94625,
                to: 122.95375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['ethylene glycol'],
        smiles: 'OCCO',
        ranges: [
            {
                signals: [
                    {
                        delta: 64.03,
                        assignment: 'CH₂',
                    },
                ],
                from: 64.02625,
                to: 64.03375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['H grease'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        delta: 30.11,
                        assignment: 'CH₂',
                    },
                ],
                from: 30.10625,
                to: 30.11375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['hexamethylbenzene'],
        smiles: 'CC1=C(C(=C(C(=C1C)C)C)C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 131.54,
                        assignment: 'C',
                    },
                ],
                from: 131.53625,
                to: 131.54375,
            },
            {
                signals: [
                    {
                        delta: 16.68,
                        assignment: 'CH₃',
                    },
                ],
                from: 16.67625,
                to: 16.68375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['n-hexane'],
        smiles: 'CCCCCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 14.18,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.17625,
                to: 14.18375,
            },
            {
                signals: [
                    {
                        delta: 22.86,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 22.85625,
                to: 22.86375,
            },
            {
                signals: [
                    {
                        delta: 31.77,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 31.76625,
                to: 31.77375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['HMDSO'],
        smiles: 'C[Si](C)(C)O[Si](C)(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 1.92,
                        assignment: 'CH₃',
                    },
                ],
                from: 1.91625,
                to: 1.9237499999999998,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['HMPA'],
        smiles: 'CN(C)P(=O)(N(C)C)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 36.64,
                        assignment: 'CH₃',
                    },
                ],
                from: 36.636250000000004,
                to: 36.64375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['imidazole'],
        smiles: 'C1=CN=CN1',
        ranges: [
            {
                signals: [
                    {
                        delta: 135.5,
                        assignment: 'CH(2)',
                    },
                ],
                from: 135.49625,
                to: 135.50375,
            },
            {
                signals: [
                    {
                        delta: 121.96,
                        assignment: 'CH(4,5)',
                    },
                ],
                from: 121.95625,
                to: 121.96374999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['methane'],
        smiles: 'C',
        ranges: [
            {
                signals: [
                    {
                        delta: -4.33,
                        assignment: 'CH₄',
                    },
                ],
                from: -4.33375,
                to: -4.32625,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['methanol'],
        smiles: 'CO',
        ranges: [
            {
                signals: [
                    {
                        delta: 49.66,
                        assignment: 'CH₃',
                    },
                ],
                from: 49.65625,
                to: 49.66374999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['nitromethane'],
        smiles: 'C[N+](=O)[O-]',
        ranges: [
            {
                signals: [
                    {
                        delta: 61.68,
                        assignment: 'CH₃',
                    },
                ],
                from: 61.67625,
                to: 61.683749999999996,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['n-pentane'],
        smiles: 'CCCCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 14.1,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.09625,
                to: 14.10375,
            },
            {
                signals: [
                    {
                        delta: 22.54,
                        assignment: 'CH₂(2,4)',
                    },
                ],
                from: 22.53625,
                to: 22.54375,
            },
            {
                signals: [
                    {
                        delta: 34.26,
                        assignment: 'CH₂(3)',
                    },
                ],
                from: 34.25625,
                to: 34.263749999999995,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['propane'],
        smiles: 'CCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 16.56,
                        assignment: 'CH₃',
                    },
                ],
                from: 16.55625,
                to: 16.56375,
            },
            {
                signals: [
                    {
                        delta: 16.48,
                        assignment: 'CH₂',
                    },
                ],
                from: 16.47625,
                to: 16.48375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['2-propanol'],
        smiles: 'CC(O)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 25.14,
                        assignment: 'CH₃',
                    },
                ],
                from: 25.13625,
                to: 25.14375,
            },
            {
                signals: [
                    {
                        delta: 64.18,
                        assignment: 'CH',
                    },
                ],
                from: 64.17625000000001,
                to: 64.18375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['propylene'],
        smiles: 'CC=C',
        ranges: [
            {
                signals: [
                    {
                        delta: 19.32,
                        assignment: 'CH₃',
                    },
                ],
                from: 19.31625,
                to: 19.32375,
            },
            {
                signals: [
                    {
                        delta: 115.86,
                        assignment: 'CH₂',
                    },
                ],
                from: 115.85625,
                to: 115.86375,
            },
            {
                signals: [
                    {
                        delta: 133.57,
                        assignment: 'CH',
                    },
                ],
                from: 133.56625,
                to: 133.57375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['pyridine'],
        smiles: 'C1=CC=NC=C1',
        ranges: [
            {
                signals: [
                    {
                        delta: 149.93,
                        assignment: 'CH(2,6)',
                    },
                ],
                from: 149.92625,
                to: 149.93375,
            },
            {
                signals: [
                    {
                        delta: 123.49,
                        assignment: 'CH(3,5)',
                    },
                ],
                from: 123.48625,
                to: 123.49374999999999,
            },
            {
                signals: [
                    {
                        delta: 135.32,
                        assignment: 'CH(4)',
                    },
                ],
                from: 135.31625,
                to: 135.32375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['pyrrole'],
        smiles: 'C1=CNC=C1',
        ranges: [
            {
                signals: [
                    {
                        delta: 117.65,
                        assignment: 'CH(2,5)',
                    },
                ],
                from: 117.64625000000001,
                to: 117.65375,
            },
            {
                signals: [
                    {
                        delta: 108.03,
                        assignment: 'CH(3,4)',
                    },
                ],
                from: 108.02625,
                to: 108.03375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['pyrrolidine'],
        smiles: 'C1CCNC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 46.75,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 46.74625,
                to: 46.75375,
            },
            {
                signals: [
                    {
                        delta: 25.59,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 25.58625,
                to: 25.59375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['silicone grease'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        delta: 1.09,
                        assignment: 'CH₃',
                    },
                ],
                from: 1.0862500000000002,
                to: 1.09375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['tetrahydrofuran'],
        smiles: 'C1COCC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 67.64,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 67.63625,
                to: 67.64375,
            },
            {
                signals: [
                    {
                        delta: 25.68,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 25.67625,
                to: 25.68375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['toluene'],
        smiles: 'Cc1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        delta: 21.23,
                        assignment: 'CH₃',
                    },
                ],
                from: 21.22625,
                to: 21.23375,
            },
            {
                signals: [
                    {
                        delta: 137.65,
                        assignment: 'C(1)',
                    },
                ],
                from: 137.64625,
                to: 137.65375,
            },
            {
                signals: [
                    {
                        delta: 129.12,
                        assignment: 'CH(2,6)',
                    },
                ],
                from: 129.11625,
                to: 129.12375,
            },
            {
                signals: [
                    {
                        delta: 128.31,
                        assignment: 'CH(3,5)',
                    },
                ],
                from: 128.30625,
                to: 128.31375,
            },
            {
                signals: [
                    {
                        delta: 125.43,
                        assignment: 'CH(4)',
                    },
                ],
                from: 125.42625000000001,
                to: 125.43375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['triethylamine'],
        smiles: 'CCN(CC)CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 11.87,
                        assignment: 'CH₃',
                    },
                ],
                from: 11.866249999999999,
                to: 11.87375,
            },
            {
                signals: [
                    {
                        delta: 46.36,
                        assignment: 'CH₂',
                    },
                ],
                from: 46.35625,
                to: 46.363749999999996,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['acetic acid'],
        smiles: 'CC(=O)O',
        ranges: [
            {
                signals: [
                    {
                        delta: 172.31,
                        assignment: 'CO',
                    },
                ],
                from: 172.30625,
                to: 172.31375,
            },
            {
                signals: [
                    {
                        delta: 20.51,
                        assignment: 'CH₃',
                    },
                ],
                from: 20.50625,
                to: 20.51375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['acetone'],
        smiles: 'CC(=O)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 205.87,
                        assignment: 'CO',
                    },
                ],
                from: 205.86625,
                to: 205.87375,
            },
            {
                signals: [
                    {
                        delta: 30.6,
                        assignment: 'CH₃',
                    },
                ],
                from: 30.59625,
                to: 30.60375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['acetonitrile'],
        smiles: 'CC#N',
        ranges: [
            {
                signals: [
                    {
                        delta: 117.6,
                        assignment: 'CN',
                    },
                ],
                from: 117.59625,
                to: 117.60374999999999,
            },
            {
                signals: [
                    {
                        delta: 1.12,
                        assignment: 'CH₃',
                    },
                ],
                from: 1.1162500000000002,
                to: 1.12375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['benzene'],
        smiles: 'c1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        delta: 129.15,
                        assignment: 'CH',
                    },
                ],
                from: 129.14625,
                to: 129.15375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['tert -butyl alcohol'],
        smiles: 'CC(C)(C)O',
        ranges: [
            {
                signals: [
                    {
                        delta: 68.13,
                        assignment: '(CH₃)₃C',
                    },
                ],
                from: 68.12625,
                to: 68.13374999999999,
            },
            {
                signals: [
                    {
                        delta: 30.72,
                        assignment: '(CH₃)₃C',
                    },
                ],
                from: 30.71625,
                to: 30.72375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['carbon dioxide'],
        smiles: 'O=C=O',
        ranges: [
            {
                signals: [
                    {
                        delta: 125.81,
                        assignment: 'CO₂',
                    },
                ],
                from: 125.80625,
                to: 125.81375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['carbon disulfide'],
        smiles: 'S=C=S',
        ranges: [
            {
                signals: [
                    {
                        delta: 193.58,
                        assignment: 'CS₂',
                    },
                ],
                from: 193.57625000000002,
                to: 193.58375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['carbon tetrachloride'],
        smiles: 'ClC(Cl)(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        delta: 96.65,
                        assignment: 'CCl₄',
                    },
                ],
                from: 96.64625000000001,
                to: 96.65375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['chloroform'],
        smiles: 'ClC(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        delta: 79.19,
                        assignment: 'CH',
                    },
                ],
                from: 79.18625,
                to: 79.19375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['18-crown-6'],
        smiles: 'C1COCCOCCOCCOCCOCCO1',
        ranges: [
            {
                signals: [
                    {
                        delta: 71.25,
                        assignment: 'CH₂',
                    },
                ],
                from: 71.24625,
                to: 71.25375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['cyclohexane'],
        smiles: 'C1CCCCC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 27.51,
                        assignment: 'CH₂',
                    },
                ],
                from: 27.50625,
                to: 27.51375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['1,2-dichloroethane'],
        smiles: 'ClCCCl',
        ranges: [
            {
                signals: [
                    {
                        delta: 45.25,
                        assignment: 'CH₂',
                    },
                ],
                from: 45.24625,
                to: 45.25375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['dichloromethane'],
        smiles: 'ClCCl',
        ranges: [
            {
                signals: [
                    {
                        delta: 54.95,
                        assignment: 'CH₂',
                    },
                ],
                from: 54.946250000000006,
                to: 54.95375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 15.78,
                        assignment: 'CH₃',
                    },
                ],
                from: 15.77625,
                to: 15.78375,
            },
            {
                signals: [
                    {
                        delta: 66.12,
                        assignment: 'CH₂',
                    },
                ],
                from: 66.11625000000001,
                to: 66.12375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['diglyme'],
        smiles: 'COCCOCCOC',
        ranges: [
            {
                signals: [
                    {
                        delta: 58.77,
                        assignment: 'CH₃',
                    },
                ],
                from: 58.76625000000001,
                to: 58.77375,
            },
            {
                signals: [
                    {
                        delta: 71.03,
                        assignment: 'CH₂',
                    },
                ],
                from: 71.02625,
                to: 71.03375,
            },
            {
                signals: [
                    {
                        delta: 72.63,
                        assignment: 'CH₂',
                    },
                ],
                from: 72.62625,
                to: 72.63374999999999,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['dimethylformamide'],
        smiles: 'C(=O)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 162.79,
                        assignment: 'CH',
                    },
                ],
                from: 162.78625,
                to: 162.79375,
            },
            {
                signals: [
                    {
                        delta: 36.15,
                        assignment: 'CH₃',
                    },
                ],
                from: 36.14625,
                to: 36.153749999999995,
            },
            {
                signals: [
                    {
                        delta: 31.03,
                        assignment: 'CH₃',
                    },
                ],
                from: 31.02625,
                to: 31.03375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['1,4-dioxane'],
        smiles: 'C1COCCOC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 67.6,
                        assignment: 'CH₂',
                    },
                ],
                from: 67.59625,
                to: 67.60374999999999,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['DME', 'diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 58.45,
                        assignment: 'CH₃',
                    },
                ],
                from: 58.446250000000006,
                to: 58.45375,
            },
            {
                signals: [
                    {
                        delta: 72.47,
                        assignment: 'CH₂',
                    },
                ],
                from: 72.46625,
                to: 72.47375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['ethane'],
        smiles: 'CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 6.88,
                        assignment: 'CH₃',
                    },
                ],
                from: 6.87625,
                to: 6.88375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['ethanol'],
        smiles: 'CCO',
        ranges: [
            {
                signals: [
                    {
                        delta: 18.89,
                        assignment: 'CH₃',
                    },
                ],
                from: 18.88625,
                to: 18.89375,
            },
            {
                signals: [
                    {
                        delta: 57.72,
                        assignment: 'CH₂',
                    },
                ],
                from: 57.71625,
                to: 57.723749999999995,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['ethyl acetate'],
        smiles: 'CC(=O)CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 20.83,
                        assignment: 'CH₃CO',
                    },
                ],
                from: 20.826249999999998,
                to: 20.83375,
            },
            {
                signals: [
                    {
                        delta: 170.96,
                        assignment: 'CO',
                    },
                ],
                from: 170.95625,
                to: 170.96375,
            },
            {
                signals: [
                    {
                        delta: 60.56,
                        assignment: 'CH₂',
                    },
                ],
                from: 60.556250000000006,
                to: 60.56375,
            },
            {
                signals: [
                    {
                        delta: 14.5,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.49625,
                to: 14.50375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['ethylene'],
        smiles: 'C=C',
        ranges: [
            {
                signals: [
                    {
                        delta: 123.47,
                        assignment: 'CH₂',
                    },
                ],
                from: 123.46625,
                to: 123.47375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['ethylene glycol'],
        smiles: 'OCCO',
        ranges: [
            {
                signals: [
                    {
                        delta: 64.26,
                        assignment: 'CH₂',
                    },
                ],
                from: 64.25625000000001,
                to: 64.26375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['H grease'],
        smiles: '',
        ranges: [],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['hexamethylbenzene'],
        smiles: 'CC1=C(C(=C(C(=C1C)C)C)C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 132.22,
                        assignment: 'C',
                    },
                ],
                from: 132.21625,
                to: 132.22375,
            },
            {
                signals: [
                    {
                        delta: 16.86,
                        assignment: 'CH₃',
                    },
                ],
                from: 16.85625,
                to: 16.86375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['n-hexane'],
        smiles: 'CCCCCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 14.34,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.33625,
                to: 14.34375,
            },
            {
                signals: [
                    {
                        delta: 23.28,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 23.27625,
                to: 23.28375,
            },
            {
                signals: [
                    {
                        delta: 32.3,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 32.29625,
                to: 32.303749999999994,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['HMDSO'],
        smiles: 'C[Si](C)(C)O[Si](C)(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 2.01,
                        assignment: 'CH₃',
                    },
                ],
                from: 2.0062499999999996,
                to: 2.01375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['HMPA'],
        smiles: 'CN(C)P(=O)(N(C)C)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 37.04,
                        assignment: 'CH₃',
                    },
                ],
                from: 37.03625,
                to: 37.043749999999996,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['imidazole'],
        smiles: 'C1=CN=CN1',
        ranges: [
            {
                signals: [
                    {
                        delta: 135.89,
                        assignment: 'CH(2)',
                    },
                ],
                from: 135.88625,
                to: 135.89374999999998,
            },
            {
                signals: [
                    {
                        delta: 122.31,
                        assignment: 'CH(4,5)',
                    },
                ],
                from: 122.30625,
                to: 122.31375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['methane'],
        smiles: 'C',
        ranges: [
            {
                signals: [
                    {
                        delta: -5.33,
                        assignment: 'CH₄',
                    },
                ],
                from: -5.33375,
                to: -5.32625,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['methanol'],
        smiles: 'CO',
        ranges: [
            {
                signals: [
                    {
                        delta: 49.77,
                        assignment: 'CH₃',
                    },
                ],
                from: 49.76625000000001,
                to: 49.77375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['nitromethane'],
        smiles: 'C[N+](=O)[O-]',
        ranges: [
            {
                signals: [
                    {
                        delta: 63.21,
                        assignment: 'CH₃',
                    },
                ],
                from: 63.206250000000004,
                to: 63.21375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['n-pentane'],
        smiles: 'CCCCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 14.29,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.286249999999999,
                to: 14.29375,
            },
            {
                signals: [
                    {
                        delta: 22.98,
                        assignment: 'CH₂(2,4)',
                    },
                ],
                from: 22.97625,
                to: 22.98375,
            },
            {
                signals: [
                    {
                        delta: 34.83,
                        assignment: 'CH₂(3)',
                    },
                ],
                from: 34.82625,
                to: 34.833749999999995,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['propane'],
        smiles: 'CCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 16.68,
                        assignment: 'CH₃',
                    },
                ],
                from: 16.67625,
                to: 16.68375,
            },
            {
                signals: [
                    {
                        delta: 16.78,
                        assignment: 'CH₂',
                    },
                ],
                from: 16.77625,
                to: 16.78375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['2-propanol'],
        smiles: 'CC(O)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 25.67,
                        assignment: 'CH₃',
                    },
                ],
                from: 25.66625,
                to: 25.673750000000002,
            },
            {
                signals: [
                    {
                        delta: 63.85,
                        assignment: 'CH',
                    },
                ],
                from: 63.846250000000005,
                to: 63.85375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['propylene'],
        smiles: 'CC=C',
        ranges: [
            {
                signals: [
                    {
                        delta: 19.42,
                        assignment: 'CH₃',
                    },
                ],
                from: 19.41625,
                to: 19.423750000000002,
            },
            {
                signals: [
                    {
                        delta: 116.03,
                        assignment: 'CH₂',
                    },
                ],
                from: 116.02625,
                to: 116.03375,
            },
            {
                signals: [
                    {
                        delta: 134.34,
                        assignment: 'CH',
                    },
                ],
                from: 134.33625,
                to: 134.34375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['pyridine'],
        smiles: 'C1=CC=NC=C1',
        ranges: [
            {
                signals: [
                    {
                        delta: 150.67,
                        assignment: 'CH(2,6)',
                    },
                ],
                from: 150.66625,
                to: 150.67374999999998,
            },
            {
                signals: [
                    {
                        delta: 124.57,
                        assignment: 'CH(3,5)',
                    },
                ],
                from: 124.56625,
                to: 124.57374999999999,
            },
            {
                signals: [
                    {
                        delta: 136.56,
                        assignment: 'CH(4)',
                    },
                ],
                from: 136.55625,
                to: 136.56375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['pyrrole'],
        smiles: 'C1=CNC=C1',
        ranges: [
            {
                signals: [
                    {
                        delta: 117.98,
                        assignment: 'CH(2,5)',
                    },
                ],
                from: 117.97625000000001,
                to: 117.98375,
            },
            {
                signals: [
                    {
                        delta: 108.04,
                        assignment: 'CH(3,4)',
                    },
                ],
                from: 108.03625000000001,
                to: 108.04375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['pyrrolidine'],
        smiles: 'C1CCNC1',
        ranges: [],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['silicone grease'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        delta: 1.4,
                        assignment: 'CH₃',
                    },
                ],
                from: 1.39625,
                to: 1.4037499999999998,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['tetrahydrofuran'],
        smiles: 'C1COCC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 68.07,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 68.06625,
                to: 68.07374999999999,
            },
            {
                signals: [
                    {
                        delta: 26.15,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 26.14625,
                to: 26.15375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['toluene'],
        smiles: 'Cc1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        delta: 21.46,
                        assignment: 'CH₃',
                    },
                ],
                from: 21.45625,
                to: 21.46375,
            },
            {
                signals: [
                    {
                        delta: 138.48,
                        assignment: 'C(1)',
                    },
                ],
                from: 138.47625,
                to: 138.48375,
            },
            {
                signals: [
                    {
                        delta: 129.76,
                        assignment: 'CH(2,6)',
                    },
                ],
                from: 129.75625,
                to: 129.76375,
            },
            {
                signals: [
                    {
                        delta: 129.03,
                        assignment: 'CH(3,5)',
                    },
                ],
                from: 129.02625,
                to: 129.03375,
            },
            {
                signals: [
                    {
                        delta: 126.12,
                        assignment: 'CH(4)',
                    },
                ],
                from: 126.11625000000001,
                to: 126.12375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['triethylamine'],
        smiles: 'CCN(CC)CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 12.49,
                        assignment: 'CH₃',
                    },
                ],
                from: 12.48625,
                to: 12.49375,
            },
            {
                signals: [
                    {
                        delta: 47.07,
                        assignment: 'CH₂',
                    },
                ],
                from: 47.066250000000004,
                to: 47.07375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['acetic acid'],
        smiles: 'CC(=O)O',
        ranges: [
            {
                signals: [
                    {
                        delta: 171.93,
                        assignment: 'CO',
                    },
                ],
                from: 171.92625,
                to: 171.93375,
            },
            {
                signals: [
                    {
                        delta: 20.95,
                        assignment: 'CH₃',
                    },
                ],
                from: 20.94625,
                to: 20.95375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['acetone'],
        smiles: 'CC(=O)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 206.31,
                        assignment: 'CO',
                    },
                ],
                from: 206.30625,
                to: 206.31375,
            },
            {
                signals: [
                    {
                        delta: 30.56,
                        assignment: 'CH₃',
                    },
                ],
                from: 30.55625,
                to: 30.56375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['acetonitrile'],
        smiles: 'CC#N',
        ranges: [
            {
                signals: [
                    {
                        delta: 117.91,
                        assignment: 'CN',
                    },
                ],
                from: 117.90625,
                to: 117.91375,
            },
            {
                signals: [
                    {
                        delta: 1.03,
                        assignment: 'CH₃',
                    },
                ],
                from: 1.02625,
                to: 1.03375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['benzene'],
        smiles: 'c1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        delta: 128.3,
                        assignment: 'CH',
                    },
                ],
                from: 128.29625000000001,
                to: 128.30375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['tert -butyl alcohol'],
        smiles: 'CC(C)(C)O',
        ranges: [
            {
                signals: [
                    {
                        delta: 66.88,
                        assignment: '(CH₃)₃C',
                    },
                ],
                from: 66.87625,
                to: 66.88374999999999,
            },
            {
                signals: [
                    {
                        delta: 30.38,
                        assignment: '(CH₃)₃C',
                    },
                ],
                from: 30.37625,
                to: 30.38375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['carbon dioxide'],
        smiles: 'O=C=O',
        ranges: [
            {
                signals: [
                    {
                        delta: 124.21,
                        assignment: 'CO₂',
                    },
                ],
                from: 124.20625,
                to: 124.21374999999999,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['carbon disulfide'],
        smiles: 'S=C=S',
        ranges: [
            {
                signals: [
                    {
                        delta: 192.63,
                        assignment: 'CS₂',
                    },
                ],
                from: 192.62625,
                to: 192.63375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['carbon tetrachloride'],
        smiles: 'ClC(Cl)(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        delta: 95.44,
                        assignment: 'CCl₄',
                    },
                ],
                from: 95.43625,
                to: 95.44375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['chloroform'],
        smiles: 'ClC(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        delta: 79.16,
                        assignment: 'CH',
                    },
                ],
                from: 79.15625,
                to: 79.16375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['18-crown-6'],
        smiles: 'C1COCCOCCOCCOCCOCCO1',
        ranges: [
            {
                signals: [
                    {
                        delta: 69.85,
                        assignment: 'CH₂',
                    },
                ],
                from: 69.84625,
                to: 69.85374999999999,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['cyclohexane'],
        smiles: 'C1CCCCC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 26.33,
                        assignment: 'CH₂',
                    },
                ],
                from: 26.326249999999998,
                to: 26.33375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['1,2-dichloroethane'],
        smiles: 'ClCCCl',
        ranges: [
            {
                signals: [
                    {
                        delta: 45.02,
                        assignment: 'CH₂',
                    },
                ],
                from: 45.01625000000001,
                to: 45.02375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['dichloromethane'],
        smiles: 'ClCCl',
        ranges: [
            {
                signals: [
                    {
                        delta: 54.84,
                        assignment: 'CH₂',
                    },
                ],
                from: 54.83625000000001,
                to: 54.84375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 15.12,
                        assignment: 'CH₃',
                    },
                ],
                from: 15.116249999999999,
                to: 15.12375,
            },
            {
                signals: [
                    {
                        delta: 62.05,
                        assignment: 'CH₂',
                    },
                ],
                from: 62.04625,
                to: 62.053749999999994,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['diglyme'],
        smiles: 'COCCOCCOC',
        ranges: [
            {
                signals: [
                    {
                        delta: 57.98,
                        assignment: 'CH₃',
                    },
                ],
                from: 57.97625,
                to: 57.98374999999999,
            },
            {
                signals: [
                    {
                        delta: 69.54,
                        assignment: 'CH₂',
                    },
                ],
                from: 69.53625000000001,
                to: 69.54375,
            },
            {
                signals: [
                    {
                        delta: 71.25,
                        assignment: 'CH₂',
                    },
                ],
                from: 71.24625,
                to: 71.25375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['dimethylformamide'],
        smiles: 'C(=O)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 162.29,
                        assignment: 'CH',
                    },
                ],
                from: 162.28625,
                to: 162.29375,
            },
            {
                signals: [
                    {
                        delta: 35.73,
                        assignment: 'CH₃',
                    },
                ],
                from: 35.72625,
                to: 35.73374999999999,
            },
            {
                signals: [
                    {
                        delta: 30.73,
                        assignment: 'CH₃',
                    },
                ],
                from: 30.72625,
                to: 30.73375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['1,4-dioxane'],
        smiles: 'C1COCCOC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 66.36,
                        assignment: 'CH₂',
                    },
                ],
                from: 66.35625,
                to: 66.36375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['DME', 'diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 58.03,
                        assignment: 'CH₃',
                    },
                ],
                from: 58.026250000000005,
                to: 58.03375,
            },
            {
                signals: [
                    {
                        delta: 71.17,
                        assignment: 'CH₂',
                    },
                ],
                from: 71.16625,
                to: 71.17375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['ethane'],
        smiles: 'CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 6.61,
                        assignment: 'CH₃',
                    },
                ],
                from: 6.60625,
                to: 6.6137500000000005,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['ethanol'],
        smiles: 'CCO',
        ranges: [
            {
                signals: [
                    {
                        delta: 18.51,
                        assignment: 'CH₃',
                    },
                ],
                from: 18.50625,
                to: 18.51375,
            },
            {
                signals: [
                    {
                        delta: 56.07,
                        assignment: 'CH₂',
                    },
                ],
                from: 56.066250000000004,
                to: 56.07375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['ethyl acetate'],
        smiles: 'CC(=O)CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 20.68,
                        assignment: 'CH₃CO',
                    },
                ],
                from: 20.67625,
                to: 20.68375,
            },
            {
                signals: [
                    {
                        delta: 170.31,
                        assignment: 'CO',
                    },
                ],
                from: 170.30625,
                to: 170.31375,
            },
            {
                signals: [
                    {
                        delta: 59.74,
                        assignment: 'CH₂',
                    },
                ],
                from: 59.736250000000005,
                to: 59.74375,
            },
            {
                signals: [
                    {
                        delta: 14.4,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.39625,
                to: 14.40375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['ethylene'],
        smiles: 'C=C',
        ranges: [
            {
                signals: [
                    {
                        delta: 123.52,
                        assignment: 'CH₂',
                    },
                ],
                from: 123.51625,
                to: 123.52374999999999,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['ethylene glycol'],
        smiles: 'OCCO',
        ranges: [
            {
                signals: [
                    {
                        delta: 62.76,
                        assignment: 'CH₂',
                    },
                ],
                from: 62.75625,
                to: 62.763749999999995,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['H grease'],
        smiles: '',
        ranges: [],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['hexamethylbenzene'],
        smiles: 'CC1=C(C(=C(C(=C1C)C)C)C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 131.1,
                        assignment: 'C',
                    },
                ],
                from: 131.09625,
                to: 131.10375,
            },
            {
                signals: [
                    {
                        delta: 16.6,
                        assignment: 'CH₃',
                    },
                ],
                from: 16.59625,
                to: 16.60375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['n-hexane'],
        smiles: 'CCCCCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 13.88,
                        assignment: 'CH₃',
                    },
                ],
                from: 13.87625,
                to: 13.883750000000001,
            },
            {
                signals: [
                    {
                        delta: 22.05,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 22.04625,
                to: 22.05375,
            },
            {
                signals: [
                    {
                        delta: 30.95,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 30.94625,
                to: 30.95375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['HMDSO'],
        smiles: 'C[Si](C)(C)O[Si](C)(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 1.96,
                        assignment: 'CH₃',
                    },
                ],
                from: 1.95625,
                to: 1.9637499999999999,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['HMPA'],
        smiles: 'CN(C)P(=O)(N(C)C)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 36.42,
                        assignment: 'CH₃',
                    },
                ],
                from: 36.416250000000005,
                to: 36.42375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['imidazole'],
        smiles: 'C1=CN=CN1',
        ranges: [
            {
                signals: [
                    {
                        delta: 135.15,
                        assignment: 'CH(2)',
                    },
                ],
                from: 135.14625,
                to: 135.15375,
            },
            {
                signals: [
                    {
                        delta: 121.55,
                        assignment: 'CH(4,5)',
                    },
                ],
                from: 121.54625,
                to: 121.55375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['methane'],
        smiles: 'C',
        ranges: [
            {
                signals: [
                    {
                        delta: -4.01,
                        assignment: 'CH₄',
                    },
                ],
                from: -4.01375,
                to: -4.00625,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['methanol'],
        smiles: 'CO',
        ranges: [
            {
                signals: [
                    {
                        delta: 48.59,
                        assignment: 'CH₃',
                    },
                ],
                from: 48.58625000000001,
                to: 48.59375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['nitromethane'],
        smiles: 'C[N+](=O)[O-]',
        ranges: [
            {
                signals: [
                    {
                        delta: 63.28,
                        assignment: 'CH₃',
                    },
                ],
                from: 63.276250000000005,
                to: 63.28375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['n-pentane'],
        smiles: 'CCCCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 13.28,
                        assignment: 'CH₃',
                    },
                ],
                from: 13.27625,
                to: 13.28375,
            },
            {
                signals: [
                    {
                        delta: 21.7,
                        assignment: 'CH₂(2,4)',
                    },
                ],
                from: 21.69625,
                to: 21.70375,
            },
            {
                signals: [
                    {
                        delta: 33.48,
                        assignment: 'CH₂(3)',
                    },
                ],
                from: 33.47625,
                to: 33.48374999999999,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['propane'],
        smiles: 'CCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 16.34,
                        assignment: 'CH₃',
                    },
                ],
                from: 16.33625,
                to: 16.34375,
            },
            {
                signals: [
                    {
                        delta: 15.67,
                        assignment: 'CH₂',
                    },
                ],
                from: 15.66625,
                to: 15.67375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['2-propanol'],
        smiles: 'CC(O)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 25.43,
                        assignment: 'CH₃',
                    },
                ],
                from: 25.42625,
                to: 25.43375,
            },
            {
                signals: [
                    {
                        delta: 64.92,
                        assignment: 'CH',
                    },
                ],
                from: 64.91625,
                to: 64.92375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['propylene'],
        smiles: 'CC=C',
        ranges: [
            {
                signals: [
                    {
                        delta: 19.2,
                        assignment: 'CH₃',
                    },
                ],
                from: 19.19625,
                to: 19.20375,
            },
            {
                signals: [
                    {
                        delta: 116.07,
                        assignment: 'CH₂',
                    },
                ],
                from: 116.06625,
                to: 116.07374999999999,
            },
            {
                signals: [
                    {
                        delta: 133.55,
                        assignment: 'CH',
                    },
                ],
                from: 133.54625000000001,
                to: 133.55375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['pyridine'],
        smiles: 'C1=CC=NC=C1',
        ranges: [
            {
                signals: [
                    {
                        delta: 149.58,
                        assignment: 'CH(2,6)',
                    },
                ],
                from: 149.57625000000002,
                to: 149.58375,
            },
            {
                signals: [
                    {
                        delta: 123.84,
                        assignment: 'CH(3,5)',
                    },
                ],
                from: 123.83625,
                to: 123.84375,
            },
            {
                signals: [
                    {
                        delta: 136.05,
                        assignment: 'CH(4)',
                    },
                ],
                from: 136.04625000000001,
                to: 136.05375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['pyrrole'],
        smiles: 'C1=CNC=C1',
        ranges: [
            {
                signals: [
                    {
                        delta: 117.32,
                        assignment: 'CH(2,5)',
                    },
                ],
                from: 117.31625,
                to: 117.32374999999999,
            },
            {
                signals: [
                    {
                        delta: 107.07,
                        assignment: 'CH(3,4)',
                    },
                ],
                from: 107.06625,
                to: 107.07374999999999,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['pyrrolidine'],
        smiles: 'C1CCNC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 46.51,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 46.50625,
                to: 46.513749999999995,
            },
            {
                signals: [
                    {
                        delta: 25.26,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 25.25625,
                to: 25.26375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['silicone grease'],
        smiles: '',
        ranges: [],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['tetrahydrofuran'],
        smiles: 'C1COCC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 67.03,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 67.02625,
                to: 67.03375,
            },
            {
                signals: [
                    {
                        delta: 25.14,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 25.13625,
                to: 25.14375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['toluene'],
        smiles: 'Cc1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        delta: 20.99,
                        assignment: 'CH₃',
                    },
                ],
                from: 20.98625,
                to: 20.99375,
            },
            {
                signals: [
                    {
                        delta: 137.35,
                        assignment: 'C(1)',
                    },
                ],
                from: 137.34625,
                to: 137.35375,
            },
            {
                signals: [
                    {
                        delta: 128.88,
                        assignment: 'CH(2,6)',
                    },
                ],
                from: 128.87625,
                to: 128.88375,
            },
            {
                signals: [
                    {
                        delta: 128.18,
                        assignment: 'CH(3,5)',
                    },
                ],
                from: 128.17625,
                to: 128.18375,
            },
            {
                signals: [
                    {
                        delta: 125.29,
                        assignment: 'CH(4)',
                    },
                ],
                from: 125.28625000000001,
                to: 125.29375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['triethylamine'],
        smiles: 'CCN(CC)CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 11.74,
                        assignment: 'CH₃',
                    },
                ],
                from: 11.73625,
                to: 11.74375,
            },
            {
                signals: [
                    {
                        delta: 45.74,
                        assignment: 'CH₂',
                    },
                ],
                from: 45.736250000000005,
                to: 45.74375,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['acetic acid'],
        smiles: 'CC(=O)O',
        ranges: [
            {
                signals: [
                    {
                        delta: 173.21,
                        assignment: 'CO',
                    },
                ],
                from: 173.20625,
                to: 173.21375,
            },
            {
                signals: [
                    {
                        delta: 20.73,
                        assignment: 'CH₃',
                    },
                ],
                from: 20.72625,
                to: 20.73375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['acetone'],
        smiles: 'CC(=O)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 207.43,
                        assignment: 'CO',
                    },
                ],
                from: 207.42625,
                to: 207.43375,
            },
            {
                signals: [
                    {
                        delta: 30.91,
                        assignment: 'CH₃',
                    },
                ],
                from: 30.90625,
                to: 30.91375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['acetonitrile'],
        smiles: 'CC#N',
        ranges: [
            {
                signals: [
                    {
                        delta: 118.26,
                        assignment: 'CN',
                    },
                ],
                from: 118.25625000000001,
                to: 118.26375,
            },
            {
                signals: [
                    {
                        delta: 1.79,
                        assignment: 'CH₃',
                    },
                ],
                from: 1.7862500000000001,
                to: 1.79375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['benzene'],
        smiles: 'c1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        delta: 129.32,
                        assignment: 'CH',
                    },
                ],
                from: 129.31625,
                to: 129.32375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['tert -butyl alcohol'],
        smiles: 'CC(C)(C)O',
        ranges: [
            {
                signals: [
                    {
                        delta: 68.74,
                        assignment: '(CH₃)₃C',
                    },
                ],
                from: 68.73625,
                to: 68.74374999999999,
            },
            {
                signals: [
                    {
                        delta: 30.68,
                        assignment: '(CH₃)₃C',
                    },
                ],
                from: 30.67625,
                to: 30.68375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['carbon dioxide'],
        smiles: 'O=C=O',
        ranges: [
            {
                signals: [
                    {
                        delta: 125.89,
                        assignment: 'CO₂',
                    },
                ],
                from: 125.88625,
                to: 125.89375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['carbon disulfide'],
        smiles: 'S=C=S',
        ranges: [
            {
                signals: [
                    {
                        delta: 193.6,
                        assignment: 'CS₂',
                    },
                ],
                from: 193.59625,
                to: 193.60375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['carbon tetrachloride'],
        smiles: 'ClC(Cl)(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        delta: 96.68,
                        assignment: 'CCl₄',
                    },
                ],
                from: 96.67625000000001,
                to: 96.68375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['chloroform'],
        smiles: 'ClC(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        delta: 79.17,
                        assignment: 'CH',
                    },
                ],
                from: 79.16625,
                to: 79.17375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['18-crown-6'],
        smiles: 'C1COCCOCCOCCOCCOCCO1',
        ranges: [
            {
                signals: [
                    {
                        delta: 71.22,
                        assignment: 'CH₂',
                    },
                ],
                from: 71.21625,
                to: 71.22375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['cyclohexane'],
        smiles: 'C1CCCCC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 27.63,
                        assignment: 'CH₂',
                    },
                ],
                from: 27.62625,
                to: 27.63375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['1,2-dichloroethane'],
        smiles: 'ClCCCl',
        ranges: [
            {
                signals: [
                    {
                        delta: 45.54,
                        assignment: 'CH₂',
                    },
                ],
                from: 45.53625,
                to: 45.543749999999996,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['dichloromethane'],
        smiles: 'ClCCl',
        ranges: [
            {
                signals: [
                    {
                        delta: 55.32,
                        assignment: 'CH₂',
                    },
                ],
                from: 55.316250000000004,
                to: 55.32375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 15.63,
                        assignment: 'CH₃',
                    },
                ],
                from: 15.62625,
                to: 15.633750000000001,
            },
            {
                signals: [
                    {
                        delta: 66.32,
                        assignment: 'CH₂',
                    },
                ],
                from: 66.31625,
                to: 66.32374999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['diglyme'],
        smiles: 'COCCOCCOC',
        ranges: [
            {
                signals: [
                    {
                        delta: 58.9,
                        assignment: 'CH₃',
                    },
                ],
                from: 58.89625,
                to: 58.903749999999995,
            },
            {
                signals: [
                    {
                        delta: 70.99,
                        assignment: 'CH₂',
                    },
                ],
                from: 70.98625,
                to: 70.99374999999999,
            },
            {
                signals: [
                    {
                        delta: 72.63,
                        assignment: 'CH₂',
                    },
                ],
                from: 72.62625,
                to: 72.63374999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['dimethylformamide'],
        smiles: 'C(=O)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 163.31,
                        assignment: 'CH',
                    },
                ],
                from: 163.30625,
                to: 163.31375,
            },
            {
                signals: [
                    {
                        delta: 36.57,
                        assignment: 'CH₃',
                    },
                ],
                from: 36.566250000000004,
                to: 36.57375,
            },
            {
                signals: [
                    {
                        delta: 31.32,
                        assignment: 'CH₃',
                    },
                ],
                from: 31.31625,
                to: 31.32375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['1,4-dioxane'],
        smiles: 'C1COCCOC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 67.72,
                        assignment: 'CH₂',
                    },
                ],
                from: 67.71625,
                to: 67.72375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['DME', 'diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 58.89,
                        assignment: 'CH₃',
                    },
                ],
                from: 58.886250000000004,
                to: 58.89375,
            },
            {
                signals: [
                    {
                        delta: 72.47,
                        assignment: 'CH₂',
                    },
                ],
                from: 72.46625,
                to: 72.47375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['ethane'],
        smiles: 'CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 6.99,
                        assignment: 'CH₃',
                    },
                ],
                from: 6.98625,
                to: 6.99375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['ethanol'],
        smiles: 'CCO',
        ranges: [
            {
                signals: [
                    {
                        delta: 18.8,
                        assignment: 'CH₃',
                    },
                ],
                from: 18.79625,
                to: 18.80375,
            },
            {
                signals: [
                    {
                        delta: 57.96,
                        assignment: 'CH₂',
                    },
                ],
                from: 57.956250000000004,
                to: 57.96375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['ethyl acetate'],
        smiles: 'CC(=O)CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 21.16,
                        assignment: 'CH₃CO',
                    },
                ],
                from: 21.15625,
                to: 21.16375,
            },
            {
                signals: [
                    {
                        delta: 171.68,
                        assignment: 'CO',
                    },
                ],
                from: 171.67625,
                to: 171.68375,
            },
            {
                signals: [
                    {
                        delta: 60.98,
                        assignment: 'CH₂',
                    },
                ],
                from: 60.97625,
                to: 60.98374999999999,
            },
            {
                signals: [
                    {
                        delta: 14.54,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.536249999999999,
                to: 14.54375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['ethylene'],
        smiles: 'C=C',
        ranges: [
            {
                signals: [
                    {
                        delta: 123.69,
                        assignment: 'CH₂',
                    },
                ],
                from: 123.68625,
                to: 123.69375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['ethylene glycol'],
        smiles: 'OCCO',
        ranges: [
            {
                signals: [
                    {
                        delta: 64.22,
                        assignment: 'CH₂',
                    },
                ],
                from: 64.21625,
                to: 64.22375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['H grease'],
        smiles: '',
        ranges: [],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['hexamethylbenzene'],
        smiles: 'CC1=C(C(=C(C(=C1C)C)C)C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 132.61,
                        assignment: 'C',
                    },
                ],
                from: 132.60625000000002,
                to: 132.61375,
            },
            {
                signals: [
                    {
                        delta: 16.94,
                        assignment: 'CH₃',
                    },
                ],
                from: 16.93625,
                to: 16.94375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['n-hexane'],
        smiles: 'CCCCCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 14.43,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.42625,
                to: 14.43375,
            },
            {
                signals: [
                    {
                        delta: 23.4,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 23.39625,
                to: 23.40375,
            },
            {
                signals: [
                    {
                        delta: 32.36,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 32.35625,
                to: 32.363749999999996,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['HMDSO'],
        smiles: 'C[Si](C)(C)O[Si](C)(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 2.07,
                        assignment: 'CH₃',
                    },
                ],
                from: 2.0662499999999997,
                to: 2.07375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['HMPA'],
        smiles: 'CN(C)P(=O)(N(C)C)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 37.1,
                        assignment: 'CH₃',
                    },
                ],
                from: 37.096250000000005,
                to: 37.10375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['imidazole'],
        smiles: 'C1=CN=CN1',
        ranges: [
            {
                signals: [
                    {
                        delta: 136.33,
                        assignment: 'CH(2)',
                    },
                ],
                from: 136.32625000000002,
                to: 136.33375,
            },
            {
                signals: [
                    {
                        delta: 122.78,
                        assignment: 'CH(4,5)',
                    },
                ],
                from: 122.77625,
                to: 122.78375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['methane'],
        smiles: 'C',
        ranges: [
            {
                signals: [
                    {
                        delta: -4.61,
                        assignment: 'CH₄',
                    },
                ],
                from: -4.6137500000000005,
                to: -4.60625,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['methanol'],
        smiles: 'CO',
        ranges: [
            {
                signals: [
                    {
                        delta: 49.9,
                        assignment: 'CH₃',
                    },
                ],
                from: 49.89625,
                to: 49.903749999999995,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['nitromethane'],
        smiles: 'C[N+](=O)[O-]',
        ranges: [
            {
                signals: [
                    {
                        delta: 63.66,
                        assignment: 'CH₃',
                    },
                ],
                from: 63.65625,
                to: 63.66374999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['n-pentane'],
        smiles: 'CCCCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 14.37,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.366249999999999,
                to: 14.37375,
            },
            {
                signals: [
                    {
                        delta: 23.08,
                        assignment: 'CH₂(2,4)',
                    },
                ],
                from: 23.076249999999998,
                to: 23.08375,
            },
            {
                signals: [
                    {
                        delta: 34.89,
                        assignment: 'CH₂(3)',
                    },
                ],
                from: 34.886250000000004,
                to: 34.89375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['propane'],
        smiles: 'CCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 16.73,
                        assignment: 'CH₃',
                    },
                ],
                from: 16.72625,
                to: 16.73375,
            },
            {
                signals: [
                    {
                        delta: 16.91,
                        assignment: 'CH₂',
                    },
                ],
                from: 16.90625,
                to: 16.91375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['2-propanol'],
        smiles: 'CC(O)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 25.55,
                        assignment: 'CH₃',
                    },
                ],
                from: 25.54625,
                to: 25.55375,
            },
            {
                signals: [
                    {
                        delta: 64.3,
                        assignment: 'CH',
                    },
                ],
                from: 64.29625,
                to: 64.30375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['propylene'],
        smiles: 'CC=C',
        ranges: [
            {
                signals: [
                    {
                        delta: 19.48,
                        assignment: 'CH₃',
                    },
                ],
                from: 19.47625,
                to: 19.48375,
            },
            {
                signals: [
                    {
                        delta: 116.12,
                        assignment: 'CH₂',
                    },
                ],
                from: 116.11625000000001,
                to: 116.12375,
            },
            {
                signals: [
                    {
                        delta: 134.78,
                        assignment: 'CH',
                    },
                ],
                from: 134.77625,
                to: 134.78375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['pyridine'],
        smiles: 'C1=CC=NC=C1',
        ranges: [
            {
                signals: [
                    {
                        delta: 150.76,
                        assignment: 'CH(2,6)',
                    },
                ],
                from: 150.75625,
                to: 150.76375,
            },
            {
                signals: [
                    {
                        delta: 127.76,
                        assignment: 'CH(3,5)',
                    },
                ],
                from: 127.75625000000001,
                to: 127.76375,
            },
            {
                signals: [
                    {
                        delta: 136.89,
                        assignment: 'CH(4)',
                    },
                ],
                from: 136.88625,
                to: 136.89374999999998,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['pyrrole'],
        smiles: 'C1=CNC=C1',
        ranges: [
            {
                signals: [
                    {
                        delta: 118.47,
                        assignment: 'CH(2,5)',
                    },
                ],
                from: 118.46625,
                to: 118.47375,
            },
            {
                signals: [
                    {
                        delta: 108.31,
                        assignment: 'CH(3,4)',
                    },
                ],
                from: 108.30625,
                to: 108.31375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['pyrrolidine'],
        smiles: 'C1CCNC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 47.57,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 47.566250000000004,
                to: 47.57375,
            },
            {
                signals: [
                    {
                        delta: 26.34,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 26.33625,
                to: 26.34375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['silicone grease'],
        smiles: '',
        ranges: [],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['tetrahydrofuran'],
        smiles: 'C1COCC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 68.33,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 68.32625,
                to: 68.33375,
            },
            {
                signals: [
                    {
                        delta: 26.27,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 26.26625,
                to: 26.27375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['toluene'],
        smiles: 'Cc1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        delta: 21.5,
                        assignment: 'CH₃',
                    },
                ],
                from: 21.49625,
                to: 21.50375,
            },
            {
                signals: [
                    {
                        delta: 138.9,
                        assignment: 'C(1)',
                    },
                ],
                from: 138.89625,
                to: 138.90375,
            },
            {
                signals: [
                    {
                        delta: 129.94,
                        assignment: 'CH(2,6)',
                    },
                ],
                from: 129.93625,
                to: 129.94375,
            },
            {
                signals: [
                    {
                        delta: 129.23,
                        assignment: 'CH(3,5)',
                    },
                ],
                from: 129.22625,
                to: 129.23375,
            },
            {
                signals: [
                    {
                        delta: 126.28,
                        assignment: 'CH(4)',
                    },
                ],
                from: 126.27625,
                to: 126.28375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['triethylamine'],
        smiles: 'CCN(CC)CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 12.38,
                        assignment: 'CH₃',
                    },
                ],
                from: 12.37625,
                to: 12.383750000000001,
            },
            {
                signals: [
                    {
                        delta: 47.1,
                        assignment: 'CH₂',
                    },
                ],
                from: 47.096250000000005,
                to: 47.10375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['acetic acid'],
        smiles: 'CC(=O)O',
        ranges: [
            {
                signals: [
                    {
                        delta: 177.96,
                        assignment: 'CO',
                    },
                ],
                from: 177.95625,
                to: 177.96375,
            },
            {
                signals: [
                    {
                        delta: 20.91,
                        assignment: 'CH₃',
                    },
                ],
                from: 20.90625,
                to: 20.91375,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['acetone'],
        smiles: 'CC(=O)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 32.35,
                        assignment: 'CO',
                    },
                ],
                from: 32.346250000000005,
                to: 32.35375,
            },
            {
                signals: [
                    {
                        delta: 214.98,
                        assignment: 'CH₃',
                    },
                ],
                from: 214.97625,
                to: 214.98375,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['acetonitrile'],
        smiles: 'CC#N',
        ranges: [
            {
                signals: [
                    {
                        delta: 118.95,
                        assignment: 'CN',
                    },
                ],
                from: 118.94625,
                to: 118.95375,
            },
            {
                signals: [
                    {
                        delta: 1,
                        assignment: 'CH₃',
                    },
                ],
                from: 0.99625,
                to: 1.00375,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['benzene'],
        smiles: 'c1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        delta: 129.84,
                        assignment: 'CH',
                    },
                ],
                from: 129.83625,
                to: 129.84375,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['tert -butyl alcohol'],
        smiles: 'CC(C)(C)O',
        ranges: [
            {
                signals: [
                    {
                        delta: 72.35,
                        assignment: '(CH₃)₃C',
                    },
                ],
                from: 72.34625,
                to: 72.35374999999999,
            },
            {
                signals: [
                    {
                        delta: 31.07,
                        assignment: '(CH₃)₃C',
                    },
                ],
                from: 31.06625,
                to: 31.07375,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['carbon dioxide'],
        smiles: 'O=C=O',
        ranges: [
            {
                signals: [
                    {
                        delta: 126.92,
                        assignment: 'CO₂',
                    },
                ],
                from: 126.91625,
                to: 126.92375,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['carbon disulfide'],
        smiles: 'S=C=S',
        ranges: [
            {
                signals: [
                    {
                        delta: 196.26,
                        assignment: 'CS₂',
                    },
                ],
                from: 196.25625,
                to: 196.26375,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['carbon tetrachloride'],
        smiles: 'ClC(Cl)(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        delta: 97.74,
                        assignment: 'CCl₄',
                    },
                ],
                from: 97.73625,
                to: 97.74374999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['chloroform'],
        smiles: 'ClC(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        delta: 78.83,
                        assignment: 'CH',
                    },
                ],
                from: 78.82625,
                to: 78.83375,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['18-crown-6'],
        smiles: 'C1COCCOCCOCCOCCOCCO1',
        ranges: [
            {
                signals: [
                    {
                        delta: 70.8,
                        assignment: 'CH₂',
                    },
                ],
                from: 70.79625,
                to: 70.80375,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['cyclohexane'],
        smiles: 'C1CCCCC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 28.34,
                        assignment: 'CH₂',
                    },
                ],
                from: 28.33625,
                to: 28.34375,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['1,2-dichloroethane'],
        smiles: 'ClCCCl',
        ranges: [
            {
                signals: [
                    {
                        delta: 45.28,
                        assignment: 'CH₂',
                    },
                ],
                from: 45.276250000000005,
                to: 45.28375,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['dichloromethane'],
        smiles: 'ClCCl',
        ranges: [
            {
                signals: [
                    {
                        delta: 54.46,
                        assignment: 'CH₂',
                    },
                ],
                from: 54.456250000000004,
                to: 54.46375,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 15.33,
                        assignment: 'CH₃',
                    },
                ],
                from: 15.32625,
                to: 15.33375,
            },
            {
                signals: [
                    {
                        delta: 67.55,
                        assignment: 'CH₂',
                    },
                ],
                from: 67.54625,
                to: 67.55375,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['diglyme'],
        smiles: 'COCCOCCOC',
        ranges: [
            {
                signals: [
                    {
                        delta: 59.4,
                        assignment: 'CH₃',
                    },
                ],
                from: 59.39625,
                to: 59.403749999999995,
            },
            {
                signals: [
                    {
                        delta: 73.05,
                        assignment: 'CH₂',
                    },
                ],
                from: 73.04625,
                to: 73.05375,
            },
            {
                signals: [
                    {
                        delta: 71.33,
                        assignment: 'CH₂',
                    },
                ],
                from: 71.32625,
                to: 71.33375,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['dimethylformamide'],
        smiles: 'C(=O)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 166.01,
                        assignment: 'CH',
                    },
                ],
                from: 166.00625,
                to: 166.01375,
            },
            {
                signals: [
                    {
                        delta: 37.76,
                        assignment: 'CH₃',
                    },
                ],
                from: 37.75625,
                to: 37.763749999999995,
            },
            {
                signals: [
                    {
                        delta: 30.96,
                        assignment: 'CH₃',
                    },
                ],
                from: 30.95625,
                to: 30.96375,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['1,4-dioxane'],
        smiles: 'C1COCCOC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 68.52,
                        assignment: 'CH₂',
                    },
                ],
                from: 68.51625,
                to: 68.52374999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['DME', 'diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 59.52,
                        assignment: 'CH₃',
                    },
                ],
                from: 59.51625000000001,
                to: 59.52375,
            },
            {
                signals: [
                    {
                        delta: 72.87,
                        assignment: 'CH₂',
                    },
                ],
                from: 72.86625000000001,
                to: 72.87375,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['ethane'],
        smiles: 'CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 7.01,
                        assignment: 'CH₃',
                    },
                ],
                from: 7.00625,
                to: 7.01375,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['ethanol'],
        smiles: 'CCO',
        ranges: [
            {
                signals: [
                    {
                        delta: 18.11,
                        assignment: 'CH₃',
                    },
                ],
                from: 18.10625,
                to: 18.11375,
            },
            {
                signals: [
                    {
                        delta: 59.68,
                        assignment: 'CH₂',
                    },
                ],
                from: 59.67625,
                to: 59.683749999999996,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['ethyl acetate'],
        smiles: 'CC(=O)CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 21.18,
                        assignment: 'CH₃CO',
                    },
                ],
                from: 21.17625,
                to: 21.18375,
            },
            {
                signals: [
                    {
                        delta: 175.55,
                        assignment: 'CO',
                    },
                ],
                from: 175.54625000000001,
                to: 175.55375,
            },
            {
                signals: [
                    {
                        delta: 62.7,
                        assignment: 'CH₂',
                    },
                ],
                from: 62.696250000000006,
                to: 62.70375,
            },
            {
                signals: [
                    {
                        delta: 14.36,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.35625,
                to: 14.36375,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['ethylene'],
        smiles: 'C=C',
        ranges: [
            {
                signals: [
                    {
                        delta: 124.08,
                        assignment: 'CH₂',
                    },
                ],
                from: 124.07625,
                to: 124.08375,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['ethylene glycol'],
        smiles: 'OCCO',
        ranges: [
            {
                signals: [
                    {
                        delta: 64.87,
                        assignment: 'CH₂',
                    },
                ],
                from: 64.86625000000001,
                to: 64.87375,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['H grease'],
        smiles: '',
        ranges: [],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['hexamethylbenzene'],
        smiles: 'CC1=C(C(=C(C(=C1C)C)C)C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 134.04,
                        assignment: 'C',
                    },
                ],
                from: 134.03625,
                to: 134.04375,
            },
            {
                signals: [
                    {
                        delta: 17.04,
                        assignment: 'CH₃',
                    },
                ],
                from: 17.03625,
                to: 17.04375,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['n-hexane'],
        smiles: 'CCCCCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 14.63,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.62625,
                to: 14.633750000000001,
            },
            {
                signals: [
                    {
                        delta: 24.06,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 24.05625,
                to: 24.06375,
            },
            {
                signals: [
                    {
                        delta: 33.17,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 33.166250000000005,
                to: 33.17375,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['HMDSO'],
        smiles: 'C[Si](C)(C)O[Si](C)(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 2.09,
                        assignment: 'CH₃',
                    },
                ],
                from: 2.0862499999999997,
                to: 2.09375,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['HMPA'],
        smiles: 'CN(C)P(=O)(N(C)C)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 37.21,
                        assignment: 'CH₃',
                    },
                ],
                from: 37.206250000000004,
                to: 37.21375,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['imidazole'],
        smiles: 'C1=CN=CN1',
        ranges: [
            {
                signals: [
                    {
                        delta: 136.58,
                        assignment: 'CH(2)',
                    },
                ],
                from: 136.57625000000002,
                to: 136.58375,
            },
            {
                signals: [
                    {
                        delta: 122.93,
                        assignment: 'CH(4,5)',
                    },
                ],
                from: 122.92625000000001,
                to: 122.93375,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['methane'],
        smiles: 'C',
        ranges: [
            {
                signals: [
                    {
                        delta: -5.88,
                        assignment: 'CH₄',
                    },
                ],
                from: -5.88375,
                to: -5.87625,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['methanol'],
        smiles: 'CO',
        ranges: [
            {
                signals: [
                    {
                        delta: 50.67,
                        assignment: 'CH₃',
                    },
                ],
                from: 50.666250000000005,
                to: 50.67375,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['nitromethane'],
        smiles: 'C[N+](=O)[O-]',
        ranges: [
            {
                signals: [
                    {
                        delta: 63.17,
                        assignment: 'CH₃',
                    },
                ],
                from: 63.166250000000005,
                to: 63.17375,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['n-pentane'],
        smiles: 'CCCCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 14.54,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.536249999999999,
                to: 14.54375,
            },
            {
                signals: [
                    {
                        delta: 23.75,
                        assignment: 'CH₂(2,4)',
                    },
                ],
                from: 23.74625,
                to: 23.75375,
            },
            {
                signals: [
                    {
                        delta: 35.76,
                        assignment: 'CH₂(3)',
                    },
                ],
                from: 35.75625,
                to: 35.763749999999995,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['propane'],
        smiles: 'CCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 16.93,
                        assignment: 'CH₃',
                    },
                ],
                from: 16.92625,
                to: 16.93375,
            },
            {
                signals: [
                    {
                        delta: 17.46,
                        assignment: 'CH₂',
                    },
                ],
                from: 17.45625,
                to: 17.46375,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['2-propanol'],
        smiles: 'CC(O)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 25.21,
                        assignment: 'CH₃',
                    },
                ],
                from: 25.20625,
                to: 25.21375,
            },
            {
                signals: [
                    {
                        delta: 66.69,
                        assignment: 'CH',
                    },
                ],
                from: 66.68625,
                to: 66.69375,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['propylene'],
        smiles: 'CC=C',
        ranges: [
            {
                signals: [
                    {
                        delta: 19.63,
                        assignment: 'CH₃',
                    },
                ],
                from: 19.62625,
                to: 19.63375,
            },
            {
                signals: [
                    {
                        delta: 116.38,
                        assignment: 'CH₂',
                    },
                ],
                from: 116.37625,
                to: 116.38374999999999,
            },
            {
                signals: [
                    {
                        delta: 136,
                        assignment: 'CH',
                    },
                ],
                from: 135.99625,
                to: 136.00375,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['pyridine'],
        smiles: 'C1=CC=NC=C1',
        ranges: [
            {
                signals: [
                    {
                        delta: 149.76,
                        assignment: 'CH(2,6)',
                    },
                ],
                from: 149.75625,
                to: 149.76375,
            },
            {
                signals: [
                    {
                        delta: 126.27,
                        assignment: 'CH(3,5)',
                    },
                ],
                from: 126.26625,
                to: 126.27374999999999,
            },
            {
                signals: [
                    {
                        delta: 139.62,
                        assignment: 'CH(4)',
                    },
                ],
                from: 139.61625,
                to: 139.62375,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['pyrrole'],
        smiles: 'C1=CNC=C1',
        ranges: [
            {
                signals: [
                    {
                        delta: 119.61,
                        assignment: 'CH(2,5)',
                    },
                ],
                from: 119.60625,
                to: 119.61375,
            },
            {
                signals: [
                    {
                        delta: 108.85,
                        assignment: 'CH(3,4)',
                    },
                ],
                from: 108.84625,
                to: 108.85374999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['pyrrolidine'],
        smiles: 'C1CCNC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 47.43,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 47.42625,
                to: 47.433749999999996,
            },
            {
                signals: [
                    {
                        delta: 25.73,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 25.72625,
                to: 25.73375,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['silicone grease'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        delta: 2.87,
                        assignment: 'CH₃',
                    },
                ],
                from: 2.86625,
                to: 2.8737500000000002,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['tetrahydrofuran'],
        smiles: 'C1COCC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 69.53,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 69.52625,
                to: 69.53375,
            },
            {
                signals: [
                    {
                        delta: 26.69,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 26.68625,
                to: 26.69375,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['toluene'],
        smiles: 'Cc1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        delta: 21.62,
                        assignment: 'CH₃',
                    },
                ],
                from: 21.61625,
                to: 21.62375,
            },
            {
                signals: [
                    {
                        delta: 139.92,
                        assignment: 'C(1)',
                    },
                ],
                from: 139.91625,
                to: 139.92374999999998,
            },
            {
                signals: [
                    {
                        delta: 130.58,
                        assignment: 'CH(2,6)',
                    },
                ],
                from: 130.57625000000002,
                to: 130.58375,
            },
            {
                signals: [
                    {
                        delta: 129.79,
                        assignment: 'CH(3,5)',
                    },
                ],
                from: 129.78625,
                to: 129.79375,
            },
            {
                signals: [
                    {
                        delta: 126.82,
                        assignment: 'CH(4)',
                    },
                ],
                from: 126.81625,
                to: 126.82374999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['triethylamine'],
        smiles: 'CCN(CC)CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 9.51,
                        assignment: 'CH₃',
                    },
                ],
                from: 9.50625,
                to: 9.51375,
            },
            {
                signals: [
                    {
                        delta: 48.45,
                        assignment: 'CH₂',
                    },
                ],
                from: 48.446250000000006,
                to: 48.45375,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['acetic acid'],
        smiles: 'CC(=O)O',
        ranges: [
            {
                signals: [
                    {
                        delta: 175.11,
                        assignment: 'CO',
                    },
                ],
                from: 175.10625000000002,
                to: 175.11375,
            },
            {
                signals: [
                    {
                        delta: 20.56,
                        assignment: 'CH₃',
                    },
                ],
                from: 20.55625,
                to: 20.56375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['acetone'],
        smiles: 'CC(=O)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 209.67,
                        assignment: 'CO',
                    },
                ],
                from: 209.66625,
                to: 209.67374999999998,
            },
            {
                signals: [
                    {
                        delta: 30.67,
                        assignment: 'CH₃',
                    },
                ],
                from: 30.66625,
                to: 30.673750000000002,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['acetonitrile'],
        smiles: 'CC#N',
        ranges: [
            {
                signals: [
                    {
                        delta: 118.06,
                        assignment: 'CN',
                    },
                ],
                from: 118.05625,
                to: 118.06375,
            },
            {
                signals: [
                    {
                        delta: 0.85,
                        assignment: 'CH₃',
                    },
                ],
                from: 0.84625,
                to: 0.85375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['benzene'],
        smiles: 'c1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        delta: 129.34,
                        assignment: 'CH',
                    },
                ],
                from: 129.33625,
                to: 129.34375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['tert -butyl alcohol'],
        smiles: 'CC(C)(C)O',
        ranges: [
            {
                signals: [
                    {
                        delta: 69.4,
                        assignment: '(CH₃)₃C',
                    },
                ],
                from: 69.39625000000001,
                to: 69.40375,
            },
            {
                signals: [
                    {
                        delta: 30.91,
                        assignment: '(CH₃)₃C',
                    },
                ],
                from: 30.90625,
                to: 30.91375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['carbon dioxide'],
        smiles: 'O=C=O',
        ranges: [
            {
                signals: [
                    {
                        delta: 126.31,
                        assignment: 'CO₂',
                    },
                ],
                from: 126.30625,
                to: 126.31375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['carbon disulfide'],
        smiles: 'S=C=S',
        ranges: [
            {
                signals: [
                    {
                        delta: 193.82,
                        assignment: 'CS₂',
                    },
                ],
                from: 193.81625,
                to: 193.82375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['carbon tetrachloride'],
        smiles: 'ClC(Cl)(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        delta: 97.21,
                        assignment: 'CCl₄',
                    },
                ],
                from: 97.20625,
                to: 97.21374999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['chloroform'],
        smiles: 'ClC(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        delta: 79.44,
                        assignment: 'CH',
                    },
                ],
                from: 79.43625,
                to: 79.44375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['18-crown-6'],
        smiles: 'C1COCCOCCOCCOCCOCCO1',
        ranges: [
            {
                signals: [
                    {
                        delta: 71.47,
                        assignment: 'CH₂',
                    },
                ],
                from: 71.46625,
                to: 71.47375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['cyclohexane'],
        smiles: 'C1CCCCC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 27.96,
                        assignment: 'CH₂',
                    },
                ],
                from: 27.95625,
                to: 27.96375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['1,2-dichloroethane'],
        smiles: 'ClCCCl',
        ranges: [
            {
                signals: [
                    {
                        delta: 45.11,
                        assignment: 'CH₂',
                    },
                ],
                from: 45.10625,
                to: 45.113749999999996,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['dichloromethane'],
        smiles: 'ClCCl',
        ranges: [
            {
                signals: [
                    {
                        delta: 54.78,
                        assignment: 'CH₂',
                    },
                ],
                from: 54.776250000000005,
                to: 54.78375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 15.46,
                        assignment: 'CH₃',
                    },
                ],
                from: 15.45625,
                to: 15.463750000000001,
            },
            {
                signals: [
                    {
                        delta: 66.88,
                        assignment: 'CH₂',
                    },
                ],
                from: 66.87625,
                to: 66.88374999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['diglyme'],
        smiles: 'COCCOCCOC',
        ranges: [
            {
                signals: [
                    {
                        delta: 59.06,
                        assignment: 'CH₃',
                    },
                ],
                from: 59.056250000000006,
                to: 59.06375,
            },
            {
                signals: [
                    {
                        delta: 71.33,
                        assignment: 'CH₂',
                    },
                ],
                from: 71.32625,
                to: 71.33375,
            },
            {
                signals: [
                    {
                        delta: 72.92,
                        assignment: 'CH₂',
                    },
                ],
                from: 72.91625,
                to: 72.92375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['dimethylformamide'],
        smiles: 'C(=O)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 164.73,
                        assignment: 'CH',
                    },
                ],
                from: 164.72625,
                to: 164.73375,
            },
            {
                signals: [
                    {
                        delta: 36.89,
                        assignment: 'CH₃',
                    },
                ],
                from: 36.886250000000004,
                to: 36.89375,
            },
            {
                signals: [
                    {
                        delta: 31.61,
                        assignment: 'CH₃',
                    },
                ],
                from: 31.60625,
                to: 31.61375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['1,4-dioxane'],
        smiles: 'C1COCCOC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 68.11,
                        assignment: 'CH₂',
                    },
                ],
                from: 68.10625,
                to: 68.11375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['DME', 'diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 59.06,
                        assignment: 'CH₃',
                    },
                ],
                from: 59.056250000000006,
                to: 59.06375,
            },
            {
                signals: [
                    {
                        delta: 72.72,
                        assignment: 'CH₂',
                    },
                ],
                from: 72.71625,
                to: 72.72375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['ethane'],
        smiles: 'CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 6.98,
                        assignment: 'CH₃',
                    },
                ],
                from: 6.97625,
                to: 6.983750000000001,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['ethanol'],
        smiles: 'CCO',
        ranges: [
            {
                signals: [
                    {
                        delta: 18.4,
                        assignment: 'CH₃',
                    },
                ],
                from: 18.39625,
                to: 18.40375,
            },
            {
                signals: [
                    {
                        delta: 58.26,
                        assignment: 'CH₂',
                    },
                ],
                from: 58.25625,
                to: 58.263749999999995,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['ethyl acetate'],
        smiles: 'CC(=O)CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 20.88,
                        assignment: 'CH₃CO',
                    },
                ],
                from: 20.87625,
                to: 20.88375,
            },
            {
                signals: [
                    {
                        delta: 172.89,
                        assignment: 'CO',
                    },
                ],
                from: 172.88625,
                to: 172.89374999999998,
            },
            {
                signals: [
                    {
                        delta: 61.5,
                        assignment: 'CH₂',
                    },
                ],
                from: 61.49625,
                to: 61.50375,
            },
            {
                signals: [
                    {
                        delta: 14.49,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.48625,
                to: 14.49375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['ethylene'],
        smiles: 'C=C',
        ranges: [
            {
                signals: [
                    {
                        delta: 123.46,
                        assignment: 'CH₂',
                    },
                ],
                from: 123.45625,
                to: 123.46374999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['ethylene glycol'],
        smiles: 'OCCO',
        ranges: [
            {
                signals: [
                    {
                        delta: 64.3,
                        assignment: 'CH₂',
                    },
                ],
                from: 64.29625,
                to: 64.30375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['H grease'],
        smiles: '',
        ranges: [],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['hexamethylbenzene'],
        smiles: 'CC1=C(C(=C(C(=C1C)C)C)C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 132.53,
                        assignment: 'C',
                    },
                ],
                from: 132.52625,
                to: 132.53375,
            },
            {
                signals: [
                    {
                        delta: 16.9,
                        assignment: 'CH₃',
                    },
                ],
                from: 16.89625,
                to: 16.90375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['n-hexane'],
        smiles: 'CCCCCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 14.45,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.44625,
                to: 14.45375,
            },
            {
                signals: [
                    {
                        delta: 23.68,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 23.67625,
                to: 23.68375,
            },
            {
                signals: [
                    {
                        delta: 32.73,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 32.72625,
                to: 32.73374999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['HMDSO'],
        smiles: 'C[Si](C)(C)O[Si](C)(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 1.99,
                        assignment: 'CH₃',
                    },
                ],
                from: 1.98625,
                to: 1.99375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['HMPA'],
        smiles: 'CN(C)P(=O)(N(C)C)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 37,
                        assignment: 'CH₃',
                    },
                ],
                from: 36.99625,
                to: 37.00375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['imidazole'],
        smiles: 'C1=CN=CN1',
        ranges: [
            {
                signals: [
                    {
                        delta: 136.31,
                        assignment: 'CH(2)',
                    },
                ],
                from: 136.30625,
                to: 136.31375,
            },
            {
                signals: [
                    {
                        delta: 122.6,
                        assignment: 'CH(4,5)',
                    },
                ],
                from: 122.59625,
                to: 122.60374999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['methane'],
        smiles: 'C',
        ranges: [
            {
                signals: [
                    {
                        delta: -4.9,
                        assignment: 'CH₄',
                    },
                ],
                from: -4.9037500000000005,
                to: -4.89625,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['methanol'],
        smiles: 'CO',
        ranges: [
            {
                signals: [
                    {
                        delta: 49.86,
                        assignment: 'CH₃',
                    },
                ],
                from: 49.85625,
                to: 49.863749999999996,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['nitromethane'],
        smiles: 'C[N+](=O)[O-]',
        ranges: [
            {
                signals: [
                    {
                        delta: 63.08,
                        assignment: 'CH₃',
                    },
                ],
                from: 63.07625,
                to: 63.083749999999995,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['n-pentane'],
        smiles: 'CCCCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 14.39,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.38625,
                to: 14.39375,
            },
            {
                signals: [
                    {
                        delta: 23.38,
                        assignment: 'CH₂(2,4)',
                    },
                ],
                from: 23.37625,
                to: 23.38375,
            },
            {
                signals: [
                    {
                        delta: 35.3,
                        assignment: 'CH₂(3)',
                    },
                ],
                from: 35.29625,
                to: 35.303749999999994,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['propane'],
        smiles: 'CCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 16.8,
                        assignment: 'CH₃',
                    },
                ],
                from: 16.79625,
                to: 16.80375,
            },
            {
                signals: [
                    {
                        delta: 17.19,
                        assignment: 'CH₂',
                    },
                ],
                from: 17.18625,
                to: 17.19375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['2-propanol'],
        smiles: 'CC(O)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 25.27,
                        assignment: 'CH₃',
                    },
                ],
                from: 25.26625,
                to: 25.27375,
            },
            {
                signals: [
                    {
                        delta: 64.71,
                        assignment: 'CH',
                    },
                ],
                from: 64.70625,
                to: 64.71374999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['propylene'],
        smiles: 'CC=C',
        ranges: [
            {
                signals: [
                    {
                        delta: 19.5,
                        assignment: 'CH₃',
                    },
                ],
                from: 19.49625,
                to: 19.50375,
            },
            {
                signals: [
                    {
                        delta: 116.04,
                        assignment: 'CH₂',
                    },
                ],
                from: 116.03625000000001,
                to: 116.04375,
            },
            {
                signals: [
                    {
                        delta: 134.61,
                        assignment: 'CH',
                    },
                ],
                from: 134.60625000000002,
                to: 134.61375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['pyridine'],
        smiles: 'C1=CC=NC=C1',
        ranges: [
            {
                signals: [
                    {
                        delta: 150.07,
                        assignment: 'CH(2,6)',
                    },
                ],
                from: 150.06625,
                to: 150.07375,
            },
            {
                signals: [
                    {
                        delta: 125.53,
                        assignment: 'CH(3,5)',
                    },
                ],
                from: 125.52625,
                to: 125.53375,
            },
            {
                signals: [
                    {
                        delta: 138.35,
                        assignment: 'CH(4)',
                    },
                ],
                from: 138.34625,
                to: 138.35375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['pyrrole'],
        smiles: 'C1=CNC=C1',
        ranges: [
            {
                signals: [
                    {
                        delta: 118.28,
                        assignment: 'CH(2,5)',
                    },
                ],
                from: 118.27625,
                to: 118.28375,
            },
            {
                signals: [
                    {
                        delta: 108.11,
                        assignment: 'CH(3,4)',
                    },
                ],
                from: 108.10625,
                to: 108.11375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['pyrrolidine'],
        smiles: 'C1CCNC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 47.23,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 47.22625,
                to: 47.23374999999999,
            },
            {
                signals: [
                    {
                        delta: 26.29,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 26.28625,
                to: 26.29375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['silicone grease'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        delta: 2.1,
                        assignment: 'CH₃',
                    },
                ],
                from: 2.09625,
                to: 2.1037500000000002,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['tetrahydrofuran'],
        smiles: 'C1COCC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 68.83,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 68.82625,
                to: 68.83375,
            },
            {
                signals: [
                    {
                        delta: 26.48,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 26.47625,
                to: 26.48375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['toluene'],
        smiles: 'Cc1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        delta: 21.5,
                        assignment: 'CH₃',
                    },
                ],
                from: 21.49625,
                to: 21.50375,
            },
            {
                signals: [
                    {
                        delta: 138.85,
                        assignment: 'C(1)',
                    },
                ],
                from: 138.84625,
                to: 138.85375,
            },
            {
                signals: [
                    {
                        delta: 129.91,
                        assignment: 'CH(2,6)',
                    },
                ],
                from: 129.90625,
                to: 129.91375,
            },
            {
                signals: [
                    {
                        delta: 129.2,
                        assignment: 'CH(3,5)',
                    },
                ],
                from: 129.19625,
                to: 129.20374999999999,
            },
            {
                signals: [
                    {
                        delta: 126.29,
                        assignment: 'CH(4)',
                    },
                ],
                from: 126.28625000000001,
                to: 126.29375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['triethylamine'],
        smiles: 'CCN(CC)CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 11.09,
                        assignment: 'CH₃',
                    },
                ],
                from: 11.08625,
                to: 11.09375,
            },
            {
                signals: [
                    {
                        delta: 46.96,
                        assignment: 'CH₂',
                    },
                ],
                from: 46.956250000000004,
                to: 46.96375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['acetic acid'],
        smiles: 'CC(=O)O',
        ranges: [
            {
                signals: [
                    {
                        delta: 177.21,
                        assignment: 'CO',
                    },
                ],
                from: 177.20625,
                to: 177.21375,
            },
            {
                signals: [
                    {
                        delta: 21.03,
                        assignment: 'CH₃',
                    },
                ],
                from: 21.02625,
                to: 21.03375,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['acetone'],
        smiles: 'CC(=O)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 215.94,
                        assignment: 'CO',
                    },
                ],
                from: 215.93625,
                to: 215.94375,
            },
            {
                signals: [
                    {
                        delta: 30.89,
                        assignment: 'CH₃',
                    },
                ],
                from: 30.88625,
                to: 30.89375,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['acetonitrile'],
        smiles: 'CC#N',
        ranges: [
            {
                signals: [
                    {
                        delta: 119.68,
                        assignment: 'CN',
                    },
                ],
                from: 119.67625000000001,
                to: 119.68375,
            },
            {
                signals: [
                    {
                        delta: 1.47,
                        assignment: 'CH₃',
                    },
                ],
                from: 1.46625,
                to: 1.47375,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['benzene'],
        smiles: 'c1ccccc1',
        ranges: [],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['tert -butyl alcohol'],
        smiles: 'CC(C)(C)O',
        ranges: [
            {
                signals: [
                    {
                        delta: 70.36,
                        assignment: '(CH₃)₃C',
                    },
                ],
                from: 70.35625,
                to: 70.36375,
            },
            {
                signals: [
                    {
                        delta: 30.29,
                        assignment: '(CH₃)₃C',
                    },
                ],
                from: 30.28625,
                to: 30.29375,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['carbon dioxide'],
        smiles: 'O=C=O',
        ranges: [],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['carbon disulfide'],
        smiles: 'S=C=S',
        ranges: [
            {
                signals: [
                    {
                        delta: 197.25,
                        assignment: 'CS₂',
                    },
                ],
                from: 197.24625,
                to: 197.25375,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['carbon tetrachloride'],
        smiles: 'ClC(Cl)(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        delta: 96.73,
                        assignment: 'CCl₄',
                    },
                ],
                from: 96.72625000000001,
                to: 96.73375,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['chloroform'],
        smiles: 'ClC(Cl)Cl',
        ranges: [],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['18-crown-6'],
        smiles: 'C1COCCOCCOCCOCCOCCO1',
        ranges: [
            {
                signals: [
                    {
                        delta: 70.14,
                        assignment: 'CH₂',
                    },
                ],
                from: 70.13625,
                to: 70.14375,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['cyclohexane'],
        smiles: 'C1CCCCC1',
        ranges: [],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['1,2-dichloroethane'],
        smiles: 'ClCCCl',
        ranges: [],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['dichloromethane'],
        smiles: 'ClCCl',
        ranges: [],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 14.77,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.76625,
                to: 14.77375,
            },
            {
                signals: [
                    {
                        delta: 66.42,
                        assignment: 'CH₂',
                    },
                ],
                from: 66.41625,
                to: 66.42375,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['diglyme'],
        smiles: 'COCCOCCOC',
        ranges: [
            {
                signals: [
                    {
                        delta: 58.67,
                        assignment: 'CH₃',
                    },
                ],
                from: 58.666250000000005,
                to: 58.67375,
            },
            {
                signals: [
                    {
                        delta: 70.05,
                        assignment: 'CH₂',
                    },
                ],
                from: 70.04625,
                to: 70.05375,
            },
            {
                signals: [
                    {
                        delta: 71.63,
                        assignment: 'CH₂',
                    },
                ],
                from: 71.62625,
                to: 71.63374999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['dimethylformamide'],
        smiles: 'C(=O)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 165.53,
                        assignment: 'CH',
                    },
                ],
                from: 165.52625,
                to: 165.53375,
            },
            {
                signals: [
                    {
                        delta: 37.54,
                        assignment: 'CH₃',
                    },
                ],
                from: 37.53625,
                to: 37.543749999999996,
            },
            {
                signals: [
                    {
                        delta: 32.03,
                        assignment: 'CH₃',
                    },
                ],
                from: 32.026250000000005,
                to: 32.03375,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['1,4-dioxane'],
        smiles: 'C1COCCOC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 67.19,
                        assignment: 'CH₂',
                    },
                ],
                from: 67.18625,
                to: 67.19375,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['DME', 'diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 58.67,
                        assignment: 'CH₃',
                    },
                ],
                from: 58.666250000000005,
                to: 58.67375,
            },
            {
                signals: [
                    {
                        delta: 71.49,
                        assignment: 'CH₂',
                    },
                ],
                from: 71.48625,
                to: 71.49374999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['ethane'],
        smiles: 'CC',
        ranges: [],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['ethanol'],
        smiles: 'CCO',
        ranges: [
            {
                signals: [
                    {
                        delta: 17.47,
                        assignment: 'CH₃',
                    },
                ],
                from: 17.46625,
                to: 17.47375,
            },
            {
                signals: [
                    {
                        delta: 58.05,
                        assignment: 'CH₂',
                    },
                ],
                from: 58.04625,
                to: 58.053749999999994,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['ethyl acetate'],
        smiles: 'CC(=O)CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 21.15,
                        assignment: 'CH₃CO',
                    },
                ],
                from: 21.14625,
                to: 21.15375,
            },
            {
                signals: [
                    {
                        delta: 175.26,
                        assignment: 'CO',
                    },
                ],
                from: 175.25625,
                to: 175.26375,
            },
            {
                signals: [
                    {
                        delta: 62.32,
                        assignment: 'CH₂',
                    },
                ],
                from: 62.316250000000004,
                to: 62.32375,
            },
            {
                signals: [
                    {
                        delta: 13.92,
                        assignment: 'CH₃',
                    },
                ],
                from: 13.91625,
                to: 13.92375,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['ethylene'],
        smiles: 'C=C',
        ranges: [],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['ethylene glycol'],
        smiles: 'OCCO',
        ranges: [
            {
                signals: [
                    {
                        delta: 63.17,
                        assignment: 'CH₂',
                    },
                ],
                from: 63.166250000000005,
                to: 63.17375,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['H grease'],
        smiles: '',
        ranges: [],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['hexamethylbenzene'],
        smiles: 'CC1=C(C(=C(C(=C1C)C)C)C)C',
        ranges: [],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['n-hexane'],
        smiles: 'CCCCCC',
        ranges: [],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['HMDSO'],
        smiles: 'C[Si](C)(C)O[Si](C)(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 2.31,
                        assignment: 'CH₃',
                    },
                ],
                from: 2.30625,
                to: 2.31375,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['HMPA'],
        smiles: 'CN(C)P(=O)(N(C)C)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 36.46,
                        assignment: 'CH₃',
                    },
                ],
                from: 36.456250000000004,
                to: 36.46375,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['imidazole'],
        smiles: 'C1=CN=CN1',
        ranges: [
            {
                signals: [
                    {
                        delta: 136.65,
                        assignment: 'CH(2)',
                    },
                ],
                from: 136.64625,
                to: 136.65375,
            },
            {
                signals: [
                    {
                        delta: 122.43,
                        assignment: 'CH(4,5)',
                    },
                ],
                from: 122.42625000000001,
                to: 122.43375,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['methane'],
        smiles: 'C',
        ranges: [],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['methanol'],
        smiles: 'CO',
        ranges: [
            {
                signals: [
                    {
                        delta: 49.5,
                        assignment: 'CH₃',
                    },
                ],
                from: 49.49625,
                to: 49.50375,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['nitromethane'],
        smiles: 'C[N+](=O)[O-]',
        ranges: [
            {
                signals: [
                    {
                        delta: 63.22,
                        assignment: 'CH₃',
                    },
                ],
                from: 63.21625,
                to: 63.223749999999995,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['n-pentane'],
        smiles: 'CCCCC',
        ranges: [],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['propane'],
        smiles: 'CCC',
        ranges: [],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['2-propanol'],
        smiles: 'CC(O)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 24.38,
                        assignment: 'CH₃',
                    },
                ],
                from: 24.37625,
                to: 24.38375,
            },
            {
                signals: [
                    {
                        delta: 64.88,
                        assignment: 'CH',
                    },
                ],
                from: 64.87625,
                to: 64.88374999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['propylene'],
        smiles: 'CC=C',
        ranges: [],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['pyridine'],
        smiles: 'C1=CC=NC=C1',
        ranges: [
            {
                signals: [
                    {
                        delta: 149.18,
                        assignment: 'CH(2,6)',
                    },
                ],
                from: 149.17625,
                to: 149.18375,
            },
            {
                signals: [
                    {
                        delta: 125.12,
                        assignment: 'CH(3,5)',
                    },
                ],
                from: 125.11625000000001,
                to: 125.12375,
            },
            {
                signals: [
                    {
                        delta: 138.27,
                        assignment: 'CH(4)',
                    },
                ],
                from: 138.26625,
                to: 138.27375,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['pyrrole'],
        smiles: 'C1=CNC=C1',
        ranges: [
            {
                signals: [
                    {
                        delta: 119.06,
                        assignment: 'CH(2,5)',
                    },
                ],
                from: 119.05625,
                to: 119.06375,
            },
            {
                signals: [
                    {
                        delta: 107.83,
                        assignment: 'CH(3,4)',
                    },
                ],
                from: 107.82625,
                to: 107.83375,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['pyrrolidine'],
        smiles: 'C1CCNC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 46.83,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 46.82625,
                to: 46.833749999999995,
            },
            {
                signals: [
                    {
                        delta: 25.86,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 25.85625,
                to: 25.86375,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['silicone grease'],
        smiles: '',
        ranges: [],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['tetrahydrofuran'],
        smiles: 'C1COCC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 68.68,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 68.67625000000001,
                to: 68.68375,
            },
            {
                signals: [
                    {
                        delta: 25.67,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 25.66625,
                to: 25.673750000000002,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['toluene'],
        smiles: 'Cc1ccccc1',
        ranges: [],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['triethylamine'],
        smiles: 'CCN(CC)CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 9.07,
                        assignment: 'CH₃',
                    },
                ],
                from: 9.06625,
                to: 9.07375,
            },
            {
                signals: [
                    {
                        delta: 47.19,
                        assignment: 'CH₂',
                    },
                ],
                from: 47.18625,
                to: 47.193749999999994,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
];
//# sourceMappingURL=carbonImpurities.js.map